<!--Menu>Outbound>Scan Pack (New)-->
<template>
    <div class="main">
        <a-divider style="margin: 0px;"/>
        <a-row style="height: 50px;background-color: white;">
            <a-col :span="18" style="display:flex;align-items:center;height:100%;">
                <span style="padding: 0 20px 0 20px;font-weight: bold;font-size: 16px;">{{$t('pubGicSet.ScanPack')}}</span>
                <a-button class="mg10" :style="{backgroundColor: packBtnType == true ? '#1677FF' : 'white',color: packBtnType ? 'white' : '#333333'}"
                          @click="clickPackSummaryBtn('pack')">{{$t('pack')}}</a-button>
                <a-button class="mg10" :style="{backgroundColor: summaryBtnType == true ? '#1677FF' : 'white',color: summaryBtnType ? 'white' : '#333333'}"
                          @click="clickPackSummaryBtn('summary')">{{$t('summary')}}</a-button>
                <a-button type="primary" class="mg10" style="margin-left: 20px;" :disabled="checkCompleteDisable" v-if="!checkCompleteDisable"
                          @click="checkPartialPack">{{$t('publicLang.CheckComplete')}}</a-button>
                <a-button type="primary" class="mg10" style="margin-left: 20px;" :disabled="confirmDisable" v-else
                          @click="shipConfirm">{{$t('publicLang.Confirm')}}</a-button>
                <a-button type="primary" class="mg10" :disabled="cancelCheckCompleteDisable"
                          @click="cancelCheckCompleteVisible = true">{{$t('publicLang.CancelCheckComplete')}}</a-button>
                <a-button type="primary" class="mg10" :disabled="!currentRelId && !waveId"
                          @click="showCourier = true" >{{$t('pubGicSet.CourierEdi')}}</a-button>
                <a-button type="primary" class="mg10" :disabled="importScanningFileDisable"
                          @click="importScanningFile()">{{$t('uploadScanningFile')}}</a-button>
                <a-button type="primary" class="mg10" :disabled="!currentRelId && !waveId"
                          @click="showPrint = true">{{$t('printDoc')}}</a-button>
            </a-col>
            <a-col style="display:flex;align-items:center;height:100%;justify-content:flex-end;padding-right:20px;padding-left: 10px;">
                <a-input class="mg10" ref="refOrderId" v-model="orderId" :placeholder="$t('searchByOrder')" @pressEnter="scanOrder()"/>
                <a-button class="mg10" style="background-color: #1677FF;color: white;" @click="scanOrder()">{{$t('skuSearch.search')}}</a-button>
            </a-col>
        </a-row>
        <a-divider style="margin: 0px;height: 5px;
                          background: linear-gradient(to top, transparent 0%, rgba(232, 232, 232, 0.3) 30%, #e8e8e8 50%, rgba(232, 232, 232, 0.7) 70%, transparent 100%);"/>
        <!--Pack page begin-->
        <div ref="refTopPack" v-show="showPack">
            <a-row :style="'height:' + topPackHeight + 'px'" style="padding-left: 20px; padding-right: 20px;overflow: auto;">
                <a-row style="height: 60px;margin-top: -3px;">
                    <a-col span="12" style="display:flex;align-items:center;height:100%;">
                        <a-button class="mg10" style="height: 40px;margin-left: 0px;"
                                  :style="{backgroundColor: pieceScanBtnType == true ? '#1677FF' : 'white',color: pieceScanBtnType ? 'white' : '#333333'}"
                                  @click="clickPieceCartonBtn('piece')">{{$t('pieceScanMode')}}</a-button>
                        <a-button class="mg10" style="height: 40px;" v-if="this.systemParam.scanpack_way != 'Y'"
                                  :style="{backgroundColor: cartonScanBtnType == true ? '#1677FF' : 'white',color: cartonScanBtnType ? 'white' : '#333333'}"
                                  @click="clickPieceCartonBtn('carton')">{{$t('cartonScanMode')}}</a-button>
                        <a-button class="mg10" style="height: 40px;" v-if="this.systemParam.scanpack_way != 'Y'"
                                  :style="{backgroundColor: traceIdScanBtnType == true ? '#1677FF' : 'white',color: traceIdScanBtnType ? 'white' : '#333333'}"
                                  @click="clickPieceCartonBtn('traceId')">{{$t('traceIdScanMode')}}</a-button>
                    </a-col>
                    <a-col span="12" style="display:flex;align-items:center;height:100%;justify-content:flex-end;">
                        <el-checkbox v-model="manualQtyEntry" :label="$t('manualQtyEntry')" class="mg10" border></el-checkbox>
                        <el-checkbox v-model="scanRemoveMode" :label="$t('scanRemoveMode')" class="mg10" style="margin-left: -10px;" border></el-checkbox>
                        <a-row v-if="!manualQtyEntry" class="mg10" style="border: 1px solid #dcdfe6;height: 50px;padding: 10px;display:flex;width: 200px;margin-left: 20px;">
                            <a-col span="12" style="display:flex;align-items:center;height:100%;">
                                {{$t('pcsPerScan')}}:
                            </a-col>
                            <a-col span="12" style="display:flex;align-items:center;height:100%;justify-content: flex-end;">
                                <a-input-number v-model:value="pcsPerScan" :min="1" :max="9999" style="width: 70px;"/>
                            </a-col>
                        </a-row>
                    </a-col>
                </a-row>
                <a-row :gutter="10">
                    <a-col :span="12" v-show="this.systemParam.SCANPACK_PACKING_INSTRUCTION">
                        <div class="gradient-orange">
                            <a-row>
                                <a-col style="color: white;padding: 10px 0 0 20px;">
                                    {{$t('packingInstructions')}}
                                </a-col>
                            </a-row>
                            <a-row>
                                <a-col style="color: white;padding: 5px 0 0 20px;font-size: 22px;font-weight: bold;cursor: pointer;"
                                       @click="showPackingInstruction = true" v-show="packingInstruction.length > 0">
                                    {{packingInstruction.length > 30 ? packingInstruction.substr(0,30)+"..." : packingInstruction}}
                                </a-col>
                            </a-row>
                        </div>
                    </a-col>
                    <a-col :span="12" v-show="this.systemParam.SCANPACK_VAS_INSTRUCTION">
                        <div class="gradient-green">
                            <a-row>
                                <a-col style="color: white;padding: 10px 0 0 20px;">
                                    {{$t('vasInstructions')}}
                                </a-col>
                            </a-row>
                            <a-row>
                                <a-col style="color: white;padding: 5px 0 0 20px;font-size: 22px;font-weight: bold;cursor: pointer;"
                                       @click="showVasInstruction = true" v-show="vasInstruction.length > 0">
                                    {{vasInstruction.length > 30 ? vasInstruction.substr(0,30)+"..." : vasInstruction}}
                                </a-col>
                            </a-row>
                        </div>
                    </a-col>
                </a-row>
                <a-row :gutter="10" style="margin-top: 10px;color: #FFFFFF">
                    <a-col :span="6">
                        <div class="shadow-blue">
                            <a-row class="font-padding">
                                {{$t('currentCarton')}}
                            </a-row>
                            <a-row style="font-size: 30px;padding: 0 0 0 20px;">
                                <span style="font-size: 48px;">{{currentCartonQty}}</span>
                                <span style= "font-size: 24px;padding-left: 10px;">{{$t('pcs')}}</span>
                            </a-row>
                        </div>
                    </a-col>
                    <a-col :span="6">
                        <div style="background-color: #FB5700;border-radius: 10px;height: 100px;box-shadow: 0 3px 10px rgba(251, 87, 0, 0.5);">
                            <a-row class="font-padding">
                                {{$t('pubGicSet.OutstandingQty')}}
                            </a-row>
                            <a-row style="font-size: 30px;padding: 0 0 0 20px;">
                                <span style="font-size: 48px;">{{totalUnPackedQty}}</span>
                                <span style= "font-size: 24px;padding-left: 10px;">{{$t('pcs')}}</span>
                            </a-row>
                        </div>
                    </a-col>
                    <a-col :span="6">
                        <div class="shadow-blue">
                            <a-row class="font-padding">
                                {{$t('pubGicSet.ScannedQty')}}
                            </a-row>
                            <a-row style="font-size: 30px;padding: 0 0 0 20px;">
                                <span style="font-size: 48px;">{{totalPackedQty}}</span>
                                <span style= "font-size: 24px;padding-left: 10px;">/</span>
                                <span style= "font-size: 24px;padding-left: 10px;">{{totalPickedQty}}</span>
                            </a-row>
                        </div>
                    </a-col>
                    <a-col :span="6">
                        <div class="shadow-blue">
                            <a-row class="font-padding">
                                {{$t('totalCartons')}}
                            </a-row>
                            <a-row style="font-size: 30px;padding: 0 0 0 20px;">
                                <span style="font-size: 48px;">{{totalCartonQty}}</span>
                                <span style= "font-size: 24px;padding-left: 10px;">{{$t('closed')}}</span>
                            </a-row>
                        </div>
                    </a-col>
                </a-row>
                <a-row :gutter="10" style="margin-top: 10px;margin-bottom: 10px;">
                    <a-col span="8">
                        <a-row class="bg-white">
                            <a-row>{{scanSkuTitle}}</a-row>
                            <a-row style="margin-top: 5px;">
                                <a-col style="display:flex;align-items:center;">
                                    <a-input ref="refScanSku" v-if="skuInput" v-model="skuCode" :placeholder="scanSkuPlaceHolder"
                                             @pressEnter="scanSku()" allowClear/>
                                    <a-input ref="refScanMaterials" v-else v-model="materialsCode" :placeholder="materialsPlaceHolder"
                                             @pressEnter="scanMaterials()" allowClear/>
                                    <a-button v-if="!scanRemoveMode" class="mg10" style="background-color: #1677FF;color: #ffffff;margin-left: 10px;cursor: auto;">
                                        {{$t('scan')}}
                                    </a-button>
                                    <a-button v-else class="mg10" type="danger" style="margin-left: 10px;cursor: auto;">{{$t('pubGicSet.RemoveSku')}}</a-button>
                                </a-col>
                            </a-row>
                            <a-row style="color: orange;padding-top: 5px;" :style="{visibility:ssccNo.length > 0 ? 'hidden' : 'visible'}">
                                {{$t('createCartonFirstScanning')}}
                            </a-row>
                        </a-row>
                        <a-row class="bg-white" style="margin-top: 10px;">
                            <a-row>
                                <a-col style="padding-left: 10px;">
                                    <a-row style="font-size: 16px;">
                                        {{$t('orderInformation')}}
                                        <!--                                        {{currentRelId}}-->
                                    </a-row>
                                    <a-divider style="margin: 0px;margin-top: 5px;margin-bottom: 5px;"/>
                                    <a-row style="display:flex;align-items:center;height:100%;">
                                        <a-col span="12">
                                            <a-row>{{$t('pubGicSet.RelID')}}</a-row>
                                            <a-row style="font-weight: bold;font-size: 18px;">{{ relId || '&nbsp;' }}</a-row>
                                        </a-col>
                                        <a-col span="12" style="display: flex;justify-content: flex-end;">
                                            <a-col v-if="isAllocated.length > 0" class="bg-orange">
                                                {{isAllocated}}
                                            </a-col>
                                        </a-col>
                                    </a-row>
                                    <a-row>
                                        <a-col>
                                            <a-row>{{$t('pubGicSet.ref01')}}</a-row>
                                            <a-row style="font-weight: bold;font-size: 18px;">{{ ref01 || '&nbsp;' }}</a-row>
                                        </a-col>
                                    </a-row>
                                    <a-row>
                                        <a-col>
                                            <a-row>{{$t('pubGicSet.WaveID')}}</a-row>
                                            <a-row style="font-weight: bold;font-size: 18px;">{{ waveId || '&nbsp;' }}</a-row>
                                        </a-col>
                                    </a-row>
                                    <a-row>
                                        <a-col span="12">
                                            <a-row>{{$t('pubGicSet.OrderType')}}</a-row>
                                            <a-row style="font-weight: bold;font-size: 18px;">{{ orderType || '&nbsp;' }}</a-row>
                                        </a-col>
                                        <a-col span="12" style="display: flex;justify-content: flex-end;align-items: center;color: red;font-size: 38px;">
                                            {{ platfromVal || '&nbsp;' }}
                                        </a-col>
                                    </a-row>
                                </a-col>
                            </a-row>
                            <a-divider style="margin: 0px;margin-top: 0px;margin-bottom: 5px;"/>
                            <a-row style="display: flex;align-items: center;">
                                <a-col span="12">
                                    {{$t('tracking')}}: {{trackingNo}}
                                </a-col>
                                <a-col span="12" style="display: flex;justify-content: flex-end;">
                                    <a-col v-if="expressName.length > 0" class="bg-orange">
                                        {{expressName}}
                                    </a-col>
                                    <a-col v-else style="height: 30px;"></a-col>
                                </a-col>
                            </a-row>
                            <a-divider style="margin: 0px;margin-top: 8px;margin-bottom: 0px;"/>
                            <a-row style="font-size: 16px;">
                                <a-col span="20">{{$t('orderItems')}}</a-col>
                                <a-col span="4" style="justify-content: flex-end;display: flex;">
                                    <div style="cursor: pointer;color: #464FCD;font-size: 16px;" @click="hiddenOrShowOrderItems">{{hiddenOrShow}}</div>
                                </a-col>
                            </a-row>
                            <div ref="refOrderItems" v-show="showOrderItems">
                                <a-row style="overflow: auto;" :style="'height:'+orderItemHeight+'px'">
                                    <a-row v-if="sortedOrderItems.length == 0" :style="'height:' + orderItemHeight + 'px;'" style="display: flex;justify-content: center;align-items: center;color: grey;"></a-row>
                                    <a-row v-else v-for="item in sortedOrderItems" class="bg-blue">
                                        <a-row>
                                            <a-col style="display: flex;justify-content: flex-start;">
                                                <div style="color: #6A98FC;font-size: 16px;">{{item.skuCode}}</div>
                                                <div style="color: #2C89C9;font-weight: bold;font-size: 16px;padding-left: 20px;" v-if="item.upc">({{item.upc}})</div>
                                            </a-col>
                                        </a-row>
                                        <a-row>{{item.skuDesc}}</a-row>
                                        <a-row style="display: flex;justify-content: flex-start;">
                                            <div>{{item.style}}</div>
                                            <div style="padding-left: 20px;">{{item.color}}</div>
                                            <div style="padding-left: 20px;">{{item.size}}</div>
                                        </a-row>
                                        <a-row style="font-size: 16px;display: flex;align-items: center;">
                                            <a-col span="12" style="">
                                                <span style="color: blue;font-size: 14px;">{{item.packedQty}}</span> /
                                                <span style="font-size: 14px;">{{item.pickedQty}}</span>
                                            </a-col>
                                            <a-col span="12" style="display: flex;justify-content: flex-end;padding-right: 10px;">
                                                <div v-if="item.pickedQty-item.packedQty > 0" style="color: orange;">
                                                    {{item.pickedQty-item.packedQty}} {{$t('pubGicSet.OutstandingQty')}}
                                                </div>
                                                <div v-else style="color: #14AA47;">
                                                    <a-icon type="check" /> {{$t('complete')}}
                                                </div>
                                            </a-col>
                                        </a-row>
                                    </a-row>
                                </a-row>
                            </div>
                        </a-row>
                    </a-col>
                    <a-col span="16">
                        <a-row class="bg-white" style="padding-left: 20px;padding-right: 20px;">
                            <a-row style="display: flex;align-items: center;height: 50px;">
                                <a-col span="12" style="font-size: 16px;">
                                    {{$t('cartonManagement')}}
                                </a-col>
                                <a-col span="12" style="display: flex;justify-content: flex-end;align-items: center;">
                                    <a-button class="mg10" style="background-color: #1677FF;color: #ffffff;"
                                              @click="createCarton(false,false)">{{$t('newCarton')}}</a-button>
                                    <a-button class="mg10" style="background-color: #E7000B;color: #ffffff;"
                                              @click="deleteCarton()">{{$t('deleteCarton')}}</a-button>
                                    <a-button class="mg10" style="background-color: #00A63E;color: #ffffff;"
                                              @click="closeCarton()">{{$t('closeCarton')}}</a-button>
                                </a-col>
                            </a-row>
                            <a-row class="bg-blue" style="display: flex;align-items: center;height: 60px;">
                                <a-col span="6">
                                    <a-col span="12"  style="font-weight: bold;padding-left: 10px;">{{$t('currentCarton')}}:</a-col>
                                    <a-col span="12" >{{currentCarton}}</a-col>
                                </a-col>
                                <a-col span="6">
                                    <a-col span="12" style="justify-content: flex-end;display: flex;padding-right: 10px;">{{$t('pubGicSet.SSCC1')}}:</a-col>
                                    <a-col span="12" style="color: #575FFC;font-weight: bold;">{{ssccNo}}</a-col>
                                </a-col>
                                <a-col span="12" style="justify-content: flex-end;display: flex;" v-if="ssccNo.length > 0">
                                    <a-col v-if="cartonStatus == 'open'" class="bg-green-tip">
                                        {{$t('open')}}
                                    </a-col>
                                    <a-col v-else class="bg-gray-tip">
                                        {{$t('closed')}}
                                    </a-col>
                                </a-col>
                            </a-row>
                            <a-row style="font-size: 16px;">
                                {{$t('cartonDetails')}}
                            </a-row>
                            <a-form :form="cartonForm">
                                <a-row style="margin-top: 3px;">
                                    <a-col span="12">
                                        {{$t('cartonSize')}}
                                        <a-form-item class="genericFrom" >
                                            <a-select optionFilterProp="label" style="width: 100%;" v-decorator="['cartonType',{ initialValue: cartonData.cartonType }]"
                                                      @change="cartonTypeChange">
                                                <a-select-option :label="item" :value="item.cartonType" :key="item.cartonType" v-for="item in systemParam.CARTON_MASTER_LIST">
                                                    {{item.cartonType}}
                                                </a-select-option>
                                            </a-select>
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row>
                                    <a-col span="2" style="margin-top: 4px;">
                                        {{$t('pubGicSet.Length')}}
                                        <a-form-item class="genericFrom">
                                            <a-input-number style="width: 100%;" :min="0" class="borderRadius" v-decorator="['length',{ initialValue: cartonData.length }]"/>
                                        </a-form-item>
                                    </a-col>
                                    <a-col span="1">
                                        <a-row span="1">&nbsp;</a-row>
                                        <a-row style="display: flex;justify-content: center;padding-top: 10px;">
                                            X
                                        </a-row>
                                    </a-col>
                                    <a-col span="2" style="margin-top: 4px;">
                                        {{$t('pubGicSet.Width')}}
                                        <a-form-item class="genericFrom" >
                                            <a-input-number :min="0" style="width: 100%;" class="borderRadius" v-decorator="['width',{ initialValue: cartonData.width }]"/>
                                        </a-form-item>
                                    </a-col>
                                    <a-col span="1">
                                        <a-row span="1">&nbsp;</a-row>
                                        <a-row style="display: flex;justify-content: center;padding-top: 10px;">
                                            X
                                        </a-row>
                                    </a-col>
                                    <a-col span="2" style="margin-top: 4px;">
                                        {{$t('pubGicSet.Height')}}
                                        <a-form-item class="genericFrom" >
                                            <a-input-number :min="0" style="width: 100%;" class="borderRadius" v-decorator="['height',{ initialValue: cartonData.height }]"/>
                                        </a-form-item>
                                    </a-col>
                                    <a-col span="2">
                                        <a-row span="1">&nbsp;</a-row>
                                        <a-row span="2">
                                            <a-form-item class="genericFrom" >
                                                <span class="gray-span">{{cartonData.dimensionUom || $t('cm')}}</span>
                                            </a-form-item>
                                        </a-row>
                                    </a-col>
                                    <a-col span="2" style="margin-top: 4px;">
                                        {{$t('pubGicSet.CBM')}}
                                        <a-form-item class="genericFrom" >
                                            <a-input-number ref="refCbm" :min="0" style="width: 100%;" class="borderRadius"
                                                            v-decorator="['cbm',{ initialValue: cartonData.cbm }]"/>
                                        </a-form-item>
                                    </a-col>
                                    <a-col span="1"></a-col>
                                    <a-col span="3" style="margin-top: 4px;">
                                        {{$t('pubGicSet.Weight')}}
                                        <a-form-item class="genericFrom" >
                                            <a-input-number ref="refWeight" :min="0" style="width: 100%;" class="borderRadius" @pressEnter="scanWeight()"
                                                            v-decorator="['grossWeight',{ initialValue: cartonData.grossWeight }]"/>
                                        </a-form-item>
                                    </a-col>
                                    <a-col span="2">
                                        <a-row span="1">&nbsp;</a-row>
                                        <a-row span="2">
                                            <a-form-item class="genericFrom" >
                                                <span class="gray-span">{{cartonData.weightUom || $t('kg')}}</span>
                                            </a-form-item>
                                        </a-row>
                                    </a-col>
                                </a-row>
                                <a-row style="font-size: 16px;">
                                    {{$t('extraInformation')}}
                                </a-row>
                                <a-row :gutter="20" style="margin-top: 3px;">
                                    <a-col span="4" v-for="item in scanPackUdf">
                                        {{item.name}}
                                        <a-form-item class="genericFrom" >
                                            <a-input class="borderRadius" v-decorator="[item.code,{ initialValue: cartonData[item.code] }]"/>
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                            </a-form>
                            <a-row style="font-size: 16px;">
                                <a-row>
                                    {{$t('itemsInCarton')}} ({{currentCartonQty}} {{$t('pcs')}})
                                </a-row>
                                <div ref="refItemsCarton">
                                    <a-row style="overflow: auto;" :style="'height:'+itemCartonHeight+'px'">
                                        <a-row v-if="filteredItemsInCarton.length == 0" :style="'height:'+itemCartonHeight+'px'" style="display: flex;justify-content: center;align-items: center;color: grey;">
                                            {{$t('noItemsScanned')}}
                                        </a-row>
                                        <a-row v-else v-for="item in filteredItemsInCarton" class="bg-green" style="align-items: center;display: flex;">
                                            <a-col span="21">
                                                <a-row>
                                                    <span style="font-size: 15px;">SKU:&nbsp;{{item.sku}}</span>
                                                    <span style="font-size: 15px;margin-left: 30px;" v-if="item.upc">({{item.upc}})</span>
                                                    <span style="font-size: 15px;margin-left: 30px;">{{item.style}}</span>
                                                    <span style="font-size: 15px;margin-left: 30px;">{{item.color}}</span>
                                                    <span style="font-size: 15px;margin-left: 30px;">{{item.size}}</span>
                                                </a-row>
                                                <a-row>{{item.skuDesc}}</a-row>
                                            </a-col>
                                            <a-col span="2" style="color: green;justify-content: center;display: flex;font-size: 20px;">
                                                {{item.packedQty}}
                                            </a-col>
                                            <a-col span="1" style="justify-content: center;display: flex;">
                                                <a-popconfirm
                                                        :title="$t('generic.AreyoudeleTask')"
                                                        @confirm="scanningMode(item)"
                                                        :okText="$t('generic.Yes')"
                                                        :cancelText="$t('generic.No')"
                                                >
                                                    <a-tooltip placement="topLeft" v-if="cartonStatus == 'open'">
                                                        <template slot="title">
                                                            <span>{{ $t('generic.Delete') }}</span>
                                                        </template>
                                                        <i class="el-icon-delete" style="color: red;font-size: 18px;cursor: pointer;padding-top: 3px;"></i>
                                                    </a-tooltip>
                                                </a-popconfirm>
                                            </a-col>
                                        </a-row>
                                    </a-row>
                                </div>
                            </a-row>
                            <a-row style="font-size: 16px;" v-if="materials || tempMaterials">
                                <a-row>
                                    {{$t('materialsInCarton')}} ({{materialsInCartonPcs}} {{$t('pcs')}})
                                </a-row>
                                <div ref="refMaterialsCarton">
                                    <a-row style="overflow: auto;height: 122px;">
                                        <a-row v-if="filteredMaterialInCarton.length == 0" style="height: 122px;display: flex;justify-content: center;align-items: center;color: grey;">
                                            {{$t('noMaterialsScanned')}}
                                        </a-row>
                                        <a-row v-else v-for="item in filteredMaterialInCarton" class="bg-buff" style="align-items: center;display: flex;">
                                            <a-col span="21">
                                                <a-row>
                                                    <span style="font-size: 15px;">{{item.type}}</span>
                                                    <span style="font-size: 15px;margin-left: 50px;">{{item.code}}</span>
                                                    <span style="font-size: 15px;margin-left: 50px;">{{item.name}}</span>
                                                </a-row>
                                            </a-col>
                                            <a-col span="2" style="color: green;justify-content: center;display: flex;font-size: 20px;">
                                                {{item.qty}}
                                            </a-col>
                                            <a-col span="1" style="justify-content: center;display: flex;">
                                                <a-popconfirm
                                                        :title="$t('generic.AreyoudeleTask')"
                                                        @confirm="scanMaterials(item)"
                                                        :okText="$t('generic.Yes')"
                                                        :cancelText="$t('generic.No')"
                                                >
                                                    <a-tooltip placement="topLeft" v-if="cartonStatus == 'open'">
                                                        <template slot="title">
                                                            <span>{{ $t('generic.Delete') }}</span>
                                                        </template>
                                                        <i class="el-icon-delete" style="color: red;font-size: 18px;cursor: pointer;padding-top: 3px;"></i>
                                                    </a-tooltip>
                                                </a-popconfirm>
                                            </a-col>
                                        </a-row>
                                    </a-row>
                                </div>
                            </a-row>
                        </a-row>
                    </a-col>
                </a-row>
            </a-row>
        </div>
        <!--Pack page end-->
        <!--Summary page begin-->
        <div ref="refTopSummary" style="padding-left: 10px; padding-right: 10px;" v-show="!showPack">
            <a-row :style="'height:' + topSummaryHeight+ 'px'" style="margin:20px 10px 0 10px;overflow: auto;" class="bg-white">
                <a-row style="display:flex;align-items:center;">
                    <a-col span="12" style="font-size: 16px;padding-left: 20px;">
                        {{$t('packingSummary')}}
                    </a-col>
                    <a-col span="12" style="display:flex;align-items:center;justify-content:flex-end;padding-right:20px;padding-left: 10px;">
                        <el-checkbox v-model="showOutstandingData" :label="$t('showOutstandingData')" style="margin-left: 20px;margin-top:5px;border-radius: 10px;" border></el-checkbox>
                        <a-input v-model="searchSsccSku" @pressEnter="searchSummaryList" class="mg10" style="width: 200px;" :placeholder="$t('skuSearch.search')"/>
                        <a-button type="primary" class="mg10" @click="exportSummary()">{{$t('generic.Export')}}</a-button>
                    </a-col>
                </a-row>
                <a-row style="margin: 10px 10px 0 10px;" :gutter="20">
                    <a-col span="6">
                        <div class="gradient-wathet">
                            <a-row>
                                <a-col style="color: #1592FD;padding: 10px 0 0 20px;">
                                    {{$t('totalOrders')}}
                                </a-col>
                            </a-row>
                            <a-row>
                                <a-col style="padding: 10px 0 0 20px;font-size: 22px;font-weight: bold;color: #1C398E">
                                    {{totalOrders}}
                                </a-col>
                            </a-row>
                        </div>
                    </a-col>
                    <a-col span="6">
                        <div class="gradient-reseda">
                            <a-row>
                                <a-col style="color: #00A63E;padding: 10px 0 0 20px;">
                                    {{$t('totalCartons')}}
                                </a-col>
                            </a-row>
                            <a-row>
                                <a-col style="padding: 10px 0 0 20px;font-size: 22px;font-weight: bold;color: #0D5470">
                                    {{totalCartons}}
                                </a-col>
                            </a-row>
                        </div>
                    </a-col>
                    <a-col span="6">
                        <div class="gradient-lilac">
                            <a-row>
                                <a-col style="color: #9A63FC;padding: 10px 0 0 20px;">
                                    {{$t('totalSKUs')}}
                                </a-col>
                            </a-row>
                            <a-row>
                                <a-col style="padding: 10px 0 0 20px;font-size: 22px;font-weight: bold;color: #701E8C">
                                    {{totalSkus}}
                                </a-col>
                            </a-row>
                        </div>
                    </a-col>
                    <a-col span="6">
                        <div class="gradient-buff">
                            <a-row>
                                <a-col style="color: #F54A00;padding: 10px 0 0 20px;">
                                    {{$t('totalPacked')}}
                                </a-col>
                            </a-row>
                            <a-row>
                                <a-col style="padding: 10px 0 0 20px;font-size: 22px;font-weight: bold;color: #863311">
                                    {{totalPacked}} {{$t('pcs')}}
                                </a-col>
                            </a-row>
                        </div>
                    </a-col>
                </a-row>
                <div ref="refSummaryTable">
                    <a-row style="margin-top: 20px;margin: 10px 10px 0 10px;">
                        <el-table ref="filterTable"
                                  :data="filteredSummaryData"
                                  :height="topSummaryHeight-180 < 400 ? 400 : topSummaryHeight-180"
                                  :empty-text="$t('userlang.NorecordFound')"
                        >
                            <el-table-column prop="relId" :label="$t('cfs.orderNo')" sortable></el-table-column>
                            <el-table-column prop="carton" :label="$t('pubGicSet.CartonNo')" sortable></el-table-column>
                            <el-table-column prop="sku" :label="$t('pubGicSet.SKU')" sortable>
                                <template slot-scope="scope">
                                    <span style="color: #4779FC;font-size: 14px;">{{ scope.row.sku }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="packedQty" :label="$t('pubGicSet.PackedQty')"></el-table-column>
                            <el-table-column prop="sscc" :label="$t('pubGicSet.SSCC1')" sortable></el-table-column>
                            <el-table-column prop="status" :label="$t('manual.Status')" sortable>
                                <template slot-scope="scope">
                                    <el-tag style="border-radius: 10px;display: flex;justify-content: center;width: 50px;"
                                            :type="scope.row.status === 'Y' ? 'info' : 'success'" disable-transitions>{{scope.row.status | filterStatus}}</el-tag>
                                </template>
                            </el-table-column>
                            <el-table-column :label="$t('job.Action')">
                                <template slot-scope="scope">
                                    <a-row :gutter="20">
                                        <a-col span="12" style="color: #546FFC;font-weight: bold;">
                                            <div style="cursor: pointer;width: 60px;" @click="clickPackSummaryBtn('open',scope.row)">
                                                <a-icon type="upload"/>
                                                <span style="margin-left: 4px;">{{$t('open')}}</span>
                                            </div>
                                        </a-col>
                                        <a-col span="12">
                                            <a-popconfirm
                                                    :title="$t('generic.AreyoudeleTask')"
                                                    @confirm="scanningMode(scope.row,true)"
                                                    :okText="$t('generic.Yes')"
                                                    :cancelText="$t('generic.No')"
                                            >
                                                <a-tooltip placement="topLeft">
                                                    <template slot="title">
                                                        <span>{{ $t('generic.Delete') }}</span>
                                                    </template>
                                                    <i class="el-icon-delete" v-if="!checkCompleteDisable"
                                                       style="color: red;font-size: 18px;cursor: pointer;padding-top: 3px;"></i>
                                                </a-tooltip>
                                            </a-popconfirm>
                                        </a-col>
                                    </a-row>
                                </template>
                            </el-table-column>
                        </el-table>
                    </a-row>
                </div>
            </a-row>
        </div>
        <!--Summary page end-->

        <!--Page Design End-->

        <!--Scan SKU popup window-->
        <a-modal v-model="showEnterQuantity" :title="showEnterQtyTitle" centered>
            <a-row :class="rowBgColor" style="padding: 10px;">
                <a-row :style="{color:fontColor}">
                    <a-col span="10" style="font-size: 18px;">{{skuItem.skuCode}}</a-col>
                    <a-col span="14" style="font-weight: bold;font-size: 18px;">({{skuItem.upc}})</a-col>
                </a-row>
                <a-row style="font-weight: bold;font-size: 16px;">{{skuItem.skuDesc}}</a-row>
                <a-row style="display: flex;align-items: flex-end;">
                    <a-col span="16">
                        <a-col span="8">
                            <a-row style="font-size: 16px;">{{$t('skuSearch.style')}}</a-row>
                            <a-row>{{skuItem.style}}</a-row>
                        </a-col>
                        <a-col span="8">
                            <a-row style="font-size: 16px;">{{$t('skuSearch.color')}}</a-row>
                            <a-row>{{skuItem.color}}</a-row>
                        </a-col>
                        <a-col span="8">
                            <a-row style="font-size: 16px;">{{$t('skuSearch.size')}}</a-row>
                            <a-row>{{skuItem.size}}</a-row>
                        </a-col>
                    </a-col>
                </a-row>
            </a-row>
            <a-row style="padding-bottom: 10px;">
                {{showEnterQtyTips}}
            </a-row>
            <a-row>
                <el-input-number ref="refPopQty" v-model="popupQuantity" controls-position="right" @change="" :min="1" :max="9999" style="width: 100%;font-weight: bold;"></el-input-number>
            </a-row>
            <template slot="footer">
                <a-button @click="showEnterQuantity = false" style="width: 48%;border-radius: 10px;height: 40px;">
                    {{$t('publicLang.Cancel')}}
                </a-button>
                <a-button type="primary" @click="confirmSku(),showEnterQuantity = false" style="width: 48%;border-radius: 10px;height: 40px;border: 1px solid;" :style="{backgroundColor:btnBgColor}">
                    {{$t('publicLang.Confirm')}}
                </a-button>
            </template>
        </a-modal>

        <!--Success Voice-->
        <audio controls="controls" ref="scanSuccessMusicRef" hidden>
            <source src="../../../assets/scan_success.mp3" type="audio/mpeg" />
        </audio>

        <!--Error Voice-->
        <a-modal :title="$t('pubGicSet.Error')" v-model="SkuExistVis" width="40%" @cancel="handleCancelSkuTishi" :maskClosable="false" :footer="null">
            <audio controls="controls" autoplay="autoplay" loop="loop" id="ScanpackmusicSKU" hidden>
                <source src="../../../assets/mm.mp3" type="audio/mpeg" />
            </audio>
            <a-alert type="error">
                <p slot="description" style="color: red;font-size: 30px;padding: 50px 0;text-align: center;line-height: 30px;" >
                    {{errMsg}}
                </p>
            </a-alert>
        </a-modal>

        <!--Check Complete Button > Partial Pack Order > Show Moving Window-->
        <a-modal v-model="showCompleteTips" :title="$t('scanPack.title')" :footer="null" @cancel="showCompleteTips = false">
            <div class="confirm-icon">
                <a-icon type="question-circle" />
            </div>
            <span style="text-align: center;margin: 0px;margin-left: 4px;font-size: 16px"> {{ $t('scanPack.cancelCheckCompleteMoveMsg') }}</span>
            <div style="display: flex;justify-content: flex-end;margin-top: 25px">
                <div>
                    <a-button style="margin-right: 10px" type="primary" @click="checkCompleteShowMoveWindow(true)">
                        {{ $t('scanPack.cancelCheckCompleteNo') }}
                    </a-button>
                    <a-button type="primary" @click="checkCompleteShowMoveWindow(false)">
                        {{ $t('scanPack.cancelCheckCompleteYes') }}
                    </a-button>
                </div>
            </div>
        </a-modal>

        <!--Cancel Check Complete Button > Show Moving Window-->
        <a-modal v-model="cancelCheckCompleteVisible" :title="$t('scanPack.title')" :footer="null" @cancel="cancelCheckCompleteVisible = false">
            <div class="confirm-icon">
                <a-icon type="question-circle" />
            </div>
            <span style="text-align: center;margin: 0px;margin-left: 4px;font-size: 16px"> {{ $t('scanPack.cancelCheckCompleteMsg') }}</span>
            <div style="display: flex;justify-content: flex-end;margin-top: 25px">
                <div>
                    <a-button style="margin-right: 10px"  type="primary" @click="cancelCheckComplete('N')" :disabled="cancelCheckCompleteRequestDisable" >
                        {{ $t('scanPack.cancelCheckCompleteNo') }}
                    </a-button>
                    <a-button type="primary"  @click="cancelCheckCompleteVisible = false,cancelCheckCompleteMoveVisibel = true" :disabled="cancelCheckCompleteRequestDisable">
                        {{ $t('scanPack.cancelCheckCompleteYes') }}
                    </a-button>
                </div>
            </div>
        </a-modal>
        <a-modal v-model="cancelCheckCompleteMoveVisibel" :title="$t('scanPack.title')" :footer="null" @cancel="cancelCheckCompleteMoveVisibel = false">
            <div class="confirm-icon">
                <a-icon type="question-circle" />
            </div>
            <span style="text-align: center;margin: 0px;margin-left: 4px;font-size: 16px"> {{ $t('scanPack.cancelCheckCompleteMoveMsg') }}</span>
            <div style="display: flex;justify-content: flex-end;margin-top: 25px">
                <div>
                    <a-button style="margin-right: 10px"  type="primary" @click="cancelCheckComplete('Y-Y')" :disabled="cancelCheckCompleteRequestDisable">
                        {{ $t('scanPack.cancelCheckCompleteNo') }}
                    </a-button>
                    <a-button type="primary"  @click="cancelCheckComplete('Y-N')" :disabled="cancelCheckCompleteRequestDisable">
                        {{ $t('scanPack.cancelCheckCompleteYes') }}
                    </a-button>
                </div>
            </div>
        </a-modal>
        <a-modal v-model="cancelPartCheckCompleteVisibel" :title="$t('scanPack.title')" :footer="null"  @cancel="cancelPartCheckCompleteVisibel = false">
            <div class="confirm-icon">
                <a-icon type="question-circle" />
            </div>
            <span style="text-align: center;margin: 0px;margin-left: 4px;font-size: 16px"> {{ $t('scanPack.firstCancelCheckCompleteThenScanPack') }}</span>
            <div style="display: flex;justify-content: flex-end;margin-top: 25px">
                <div>
                    <a-button style="margin-right: 10px"  type="primary" @click="cancelPartCheckCompleteVisibel = false" >
                        {{ $t('scanPack.cancelCheckCompleteNo') }}
                    </a-button>
                    <a-button type="primary"  @click="cancelPartCheckComplete" >
                        {{ $t('scanPack.cancelCheckCompleteYes') }}
                    </a-button>
                </div>
            </div>
        </a-modal>

        <!--Instruction Show Window-->
        <a-modal :title="$t('packingInstructions')" width="50%" :visible="showPackingInstruction" @cancel="showPackingInstruction = false" centered :maskClosable="false">
            <div class="bg-yellow">{{ packingInstruction }}</div>
            <template slot="footer">
                <a-button style="background-color: #1677FF;color: white;border-radius: 10px;" @click="showPackingInstruction = false">{{ $t('publicLang.Close') }}</a-button>
            </template>
        </a-modal>
        <a-modal :title="$t('vasInstructions')" width="50%" :visible="showVasInstruction" @cancel="showVasInstruction = false" centered :maskClosable="false">
            <div class="bg-tiffany-blue">{{ vasInstruction }}</div>
            <template slot="footer">
                <a-button style="background-color: #1677FF;color: white;border-radius: 10px;" @click="showVasInstruction = false">{{ $t('publicLang.Close') }}</a-button>
            </template>
        </a-modal>

        <delivery-date ref="deliveryDate" v-on:deliverdate="searchOrder()"></delivery-date>
        <scan-pack-move ref="adjustMove" ></scan-pack-move>

        <!--Courier EDI-->
        <a-modal :title="$t('pubGicSet.CourierEdi')" width="50%" :visible="showCourier" @cancel="showCourier = false" :footer="null" centered :maskClosable="false">
            <div v-for="item in btnFunArr" v-if="item.code != 'Print'" style="margin-bottom: 8px;">
                <div v-if="item.arr.length > 0" style="color: #30A0D6;font-weight: bold;margin-left: 10px;">{{item.code}}</div>
                <div style="display: flex; justify-content: flex-start; flex-wrap: wrap; gap: 8px;">
                    <div v-for="tt in item.arr" :key="tt.uid" @click="printPDFByBtnConfig(tt)" class="gray-border" style="padding: 4px 0px;">
                        {{tt.name}}
                    </div>
                </div>
            </div>

        </a-modal>

        <import-scanning-file ref="importScanningFile" v-on:cancelImport="GETcancelImport"></import-scanning-file>

        <!--Print Doc-->
        <a-modal :title="$t('printDoc')" width="50%" :visible="showPrint" @cancel="resetPrint" centered :maskClosable="false">
            <div v-for="item in btnFunArr" v-if="item.code == 'Print'" style="display: inline-flex;justify-content: flex-start; flex-wrap: wrap;">
                <div v-for="tt in item.arr" :key="tt.uid" class="gray-border" style="padding: 4px 0px;" @click="toggleCheckbox(tt)">
                    <div class="checkbox-wrapper">
                        <a-checkbox :checked="checkedUids.some(id => String(id) === String(tt.uid))"></a-checkbox>
                    </div>
                    <span style="word-break: break-all;">{{tt.name}}</span>
                </div>
            </div>
            <template slot="footer">
                <a-button type="primary" @click="previewDoc" style="width: 100px;">{{ $t('publicLang.Preview') }}</a-button>
                <a-button type="primary" :disabled="disabledPrint" @click="printDoc" style="width: 100px;">{{ $t('pubGicSet.Print') }}</a-button>
            </template>
        </a-modal>

    </div>
</template>
<script>
    import { mapState } from "vuex";
    import Template from "../reportCom/template";
    import ajax from "../../../api/ajax";
    import api from "../../../api/url";
    import deliveryDate from "./deliverydate";
    import scanPackMove from './scanPackMove.vue'
    import axios from "axios";
    import cookie from "../../../api/cookie";
    import webSocketPrint from "./webSocketPrint";
    import importScanningFile from "./importScanningFile";
    let that;
    export default {
        components: {
            Template,
            deliveryDate,
            scanPackMove,
            importScanningFile,
        },
        data() {
            return {
                SkuExistVis: false,
                showCompleteTips:false,
                cancelCheckCompleteVisible : false,
                cancelCheckCompleteMoveVisibel :  false,
                cancelPartCheckCompleteVisibel: false,
                cancelCheckCompleteRequestDisable: false,
                errMsg:"",
                packBtnType:true,
                summaryBtnType:false,
                checkCompleteDisable:true,
                cancelCheckCompleteDisable:true,
                confirmDisable:true,
                importScanningFileDisable:true,
                pieceScanBtnType:true,
                cartonScanBtnType:false,
                traceIdScanBtnType:false,
                manualQtyEntry:false,
                scanRemoveMode:false,
                showOutstandingData:false,
                searchSsccSku:"",
                cartonForm: this.$form.createForm(this),
                orderId:"",
                scanSkuTitle:this.$t('pieceScanMode'),
                scanSkuPlaceHolder:this.$t('scanBarcodeHere'),
                materialsPlaceHolder:this.$t('scanMaterialsHere'),
                skuCode:"",
                poNo:"",
                materialsCode:"",
                materialsCodeList:[],
                materials:false,
                multiplematerials:false,
                tempMaterials:false,
                materialsInCarton:[],
                materialsInCartonPcs:0,
                cartonCode:"",
                packingInstruction:"",
                showPackingInstruction:false,
                vasInstruction:"",
                showVasInstruction:false,
                displayText: "",
                loading:false,
                pcsPerScan:1,
                popupQuantity:1,
                ssccNo:"",
                cartonStatus:'open',
                cartonUid:"",
                relId:"",
                currentRelId:"",
                cartonData: {},
                ref01:"",
                orderType:"",
                trackingNo:"",
                expressName:"",
                waveId:"",
                platfromVal:"",
                isAllocated:"",
                skuInput:true,
                currentCarton:"",
                showPack:true,
                showEnterQuantity:false,
                showEnterQtyTitle:"",
                showEnterQtyTips:"",
                rowBgColor:"",
                btnBgColor:"",
                fontColor:"",
                showOrderItems:true,
                hiddenOrShow:this.$t('hide'),
                orderItems:[],
                skuItem:{},
                totalPickedQty:0,
                totalPackedQty:0,
                totalUnPackedQty:0,
                totalCartonQty:0,
                itemsInCarton:[],
                currentCartonQty:0,
                topPackHeight: 0,
                topSummaryHeight: 0,
                orderItemHeight: 98,
                itemCartonHeight: 136,
                summaryData: [],
                ssccStatus:[
                    {title:this.$t('open'),value:"N"},
                    {title:this.$t('closed'),value:"Y"},
                ],
                scanPackDtoList:[],
                scanPackUdf:[],
                showCourier:false,
                showPrint:false,
                btnFunArr:[],
                ip:"",
                checkedUids:[],
                checkedItems:[],
                autoPrintLable:[],
                disabledPrint:true,
                gmcUid:"",
            }
        },
        computed: {
            ...mapState(["systemParam"]),
            sortedOrderItems() {
                return [...this.orderItems].sort((a, b) => {
                    const aPicked = Number(a.pickedQty) || 0;
                    const aPacked = Number(a.packedQty) || 0;
                    const bPicked = Number(b.pickedQty) || 0;
                    const bPacked = Number(b.packedQty) || 0;
                    const getWeight = (picked, packed) => {
                        if (0 < packed && packed < picked){
                            return 0;
                        }
                        if (packed === 0){
                            return 1;
                        }else {
                            return 2;
                        }
                    };
                    const aWeight = getWeight(aPicked, aPacked);
                    const bWeight = getWeight(bPicked, bPacked);
                    if (aWeight !== bWeight) {
                        return aWeight - bWeight;
                    }
                    const aSort = aPicked - aPacked;
                    const bSort = bPicked - bPacked;
                    return bSort - aSort;
                });
            },
            filteredItemsInCarton() {
                return this.itemsInCarton.filter(item => {
                    if (item.packedQty === undefined || item.packedQty === null) return false;
                    return Number(item.packedQty) > 0;
                });
            },
            filteredMaterialInCarton() {
                return this.materialsInCarton.filter(item => {
                    if (item.qty === undefined || item.qty === null) return false;
                    return Number(item.qty) > 0;
                });
            },
            filteredSummaryData() {
                if (!this.summaryData.length){
                    return [];
                }
                return this.summaryData.filter(item => {
                    return this.showOutstandingData ? item.status === 'N' : true;
                });
            },
            totalOrders() {
                let total = new Set();
                for(let item of this.filteredSummaryData){
                    total.add(item.order);
                }
                return total.size;
            },
            totalCartons() {
                let total = new Set();
                for(let item of this.filteredSummaryData){
                    total.add(item.sscc);
                }
                return total.size;
            },
            totalSkus() {
                let total = new Set();
                for(let item of this.filteredSummaryData){
                    total.add(item.sku);
                }
                return total.size;
            },
            totalPacked() {
                let total = 0;
                for(let item of this.filteredSummaryData){
                    total += item.packedQty;
                }
                return total;
            },
        },
        mounted() {
            this.getUserIP((ip) => {
                this.ip = ip;
            });
            this.handleResize();
            window.addEventListener('resize', this.handleResize);
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.handleResize);
        },
        activated() {
            this.handleResize();
            this.$nextTick(() => {
                this.$refs.refOrderId.select();
            });
        },
        created() {
            that = this;
            this.$nextTick(() => {
                this.$refs.refOrderId.focus();
            });
            this.getSysConfig();
            this.$nextTick(() => {
                setTimeout(() => {
                    this.handleResize();
                }, 1000);
            });
            this.getMaterials();
        },
        beforeRouteLeave(to, from, next) {
            const isClose = sessionStorage.getItem('closeScanPackNewPage');
            if (isClose === 'true') {
                this.resetOrder();
                sessionStorage.removeItem('closeScanPackNewPage');
            }
            next();
        },
        filters: {
            filterStatus(val) {
                let sta = that.ssccStatus;
                for(let i in sta){
                    if(val == sta[i].value){
                        return sta[i].title
                    }
                }
            }
        },
        methods: {
            handleResize() {
                this.$nextTick(() => {
                    if (this.$refs.refTopPack) {
                        this.topPackHeight = window.innerHeight - this.$refs.refTopPack.getBoundingClientRect().top;
                    }
                    if (this.$refs.refTopSummary) {
                        this.topSummaryHeight = window.innerHeight - this.$refs.refTopSummary.getBoundingClientRect().top-20;
                    }
                    let widowHeight = window.innerHeight;
                    if(this.materials || this.tempMaterials){
                        this.itemCartonHeight = widowHeight - Math.abs(this.$refs.refItemsCarton.getBoundingClientRect().top) - 30 - 136;
                        this.itemCartonHeight = Math.max(this.itemCartonHeight, 136);
                        this.orderItemHeight = (Math.abs(this.$refs.refOrderItems.getBoundingClientRect().top) -
                            Math.abs(this.$refs.refItemsCarton.getBoundingClientRect().top)) + this.itemCartonHeight + 68;
                        this.orderItemHeight = Math.max(this.orderItemHeight, 98);
                    }else{
                        this.itemCartonHeight = widowHeight - Math.abs(this.$refs.refItemsCarton.getBoundingClientRect().top) - 30;
                        this.itemCartonHeight = Math.max(this.itemCartonHeight, 136);
                        this.orderItemHeight = widowHeight - Math.abs(this.$refs.refOrderItems.getBoundingClientRect().top) - 30;
                        this.orderItemHeight = Math.max(this.orderItemHeight, 98);
                    }
                });
            },
            getAutoPrintLabel(gmcUid){
                let params = {
                    gmcUid: gmcUid
                };
                ajax.get(api.SCANPACKNEWGETAUTOPRINTLABEL,params).then(res=>{
                    this.autoPrintLable = res.data;
                })
            },
            audioPubFun(msg) {
                this.SkuExistVis = true;
                this.errMsg = msg;
                let audio = document.getElementById("ScanpackmusicSKU");
                if (audio !== null) {
                    if (audio.paused) {
                        audio.play();
                    }
                }
            },
            handleCancelSkuTishi() {
                this.SkuExistVis = false;
                let audio = document.getElementById("ScanpackmusicSKU");
                if (audio !== null) {
                    if (!audio.paused) {
                        audio.pause();
                    }
                }
            },
            clickPackSummaryBtn(val,item){
                if(val == 'pack'){
                    this.packBtnType = true;
                    this.summaryBtnType = false;
                    this.showPack = true;
                }else if(val == 'summary') {
                    this.summaryBtnType = true;
                    this.packBtnType = false;
                    this.showPack = false;
                    this.searchSummaryList();
                }else if(val == 'open'){
                    if(item != undefined){//Open
                        this.openCarton(item);
                    }
                }
                this.getScanPackStatus();
                this.handleResize();
            },
            hiddenOrShowOrderItems(){
                this.showOrderItems = !this.showOrderItems;
                if(this.showOrderItems){
                    this.hiddenOrShow = this.$t('hide');
                }else{
                    this.hiddenOrShow = this.$t('show');
                }
                this.handleResize();
            },
            clickPieceCartonBtn(val){
                if(val == 'piece'){
                    this.pieceScanBtnType = true;
                    this.cartonScanBtnType = false;
                    this.traceIdScanBtnType = false;
                    this.resetPieceScanMode();
                }else if(val == 'carton'){
                    this.cartonScanBtnType = true;
                    this.pieceScanBtnType = false;
                    this.traceIdScanBtnType = false;
                    this.scanSkuTitle = this.$t('cartonScanMode');
                    this.scanSkuPlaceHolder = this.$t('scanCartonHere');
                }else if(val == 'traceId'){
                    this.traceIdScanBtnType = true;
                    this.pieceScanBtnType = false;
                    this.cartonScanBtnType = false;
                    this.scanSkuTitle = this.$t('traceIdScanMode');
                    this.scanSkuPlaceHolder = this.$t('scanTraceIdHere');
                }
            },
            resetOrder(){
                this.packBtnType = true;
                this.summaryBtnType = false;
                this.showPack = true;
                this.orderId = "";
                this.checkCompleteDisable = true;
                this.cancelCheckCompleteDisable = true;
                this.confirmDisable = true;
                this.importScanningFileDisable = true;
                this.orderItems = [];
                this.itemsInCarton = [];
                this.relId = "";
                this.currentRelId = "";
                this.ref01 = "";
                this.waveId = "";
                this.orderType = "";
                this.platfromVal = "";
                this.trackingNo = "";
                this.expressName = "";
                this.isAllocated = "";
                this.ssccNo = "";
                this.currentCarton = "";
                this.currentCartonQty = 0;
                this.totalUnPackedQty = 0;
                this.totalPackedQty = 0;
                this.totalPickedQty = 0;
                this.totalCartonQty = 0;
                this.materials = false;
                this.tempMaterials = false;
                this.summaryData = [];
                this.pieceScanBtnType = true;
                this.cartonScanBtnType = false;
                this.traceIdScanBtnType = false;
                this.packingInstruction = "";
                this.vasInstruction = "";
                this.searchSsccSku = "";
                this.resetPieceScanMode();
            },
            resetPieceScanMode(){
                this.skuInput = true;
                this.scanSkuTitle = this.$t('pieceScanMode');
                this.scanSkuPlaceHolder = this.$t('scanBarcodeHere');
                this.$nextTick(() => {
                    this.skuCode = "";
                    this.materialsCode = "";
                    this.$refs.refScanSku.focus();
                });
            },
            resetMaterialScanMode(){
                this.skuInput = false;
                this.scanSkuTitle = this.$t('materialsScanMode');
                this.$nextTick(() => {
                    this.skuCode = "";
                    this.materialsCode = "";
                    this.$refs.refScanMaterials.focus();
                });
            },
            init(){
                this.scanOrder();
            },
            scanOrder(){
                if(this.packBtnType){
                    this.pieceScanBtnType = true;
                    this.cartonScanBtnType = false;
                    this.traceIdScanBtnType = false;
                    this.resetPieceScanMode();
                    this.scanRemoveMode = false;
                    this.resetCarton();
                    this.currentRelId = "";
                    this.checkedUids = [];
                    this.checkedItems = [];
                }else if(this.summaryBtnType){
                    this.searchSummaryList();
                }
                this.searchOrder();
            },
            searchOrder(){
                if(this.orderId.length < 1){
                    this.resetOrder();
                    return;
                }
                this.getInstruction();
                let params = {
                    orderNo : this.orderId
                }
                ajax.get(api.SCANPACKNEWBYORDER, params).then(res => {
                    this.skuCode = "";
                    if (res.code == 200) {
                        this.orderItems = res.data.list;
                        let totalQty = 0;
                        let packedQty = 0;
                        for(let item of this.orderItems){
                            totalQty += item.pickedQty;
                            packedQty += item.packedQty;
                        }
                        this.totalPickedQty = totalQty;
                        this.totalPackedQty = packedQty;
                        this.totalUnPackedQty = totalQty - packedQty;
                        this.totalCartonQty = res.data.totalCartonQty;
                        this.relId = res.data.relId;
                        if(!res.data.relId.startsWith("Multiple")){
                            this.currentRelId = res.data.relId;
                        }
                        this.ref01 = res.data.ref01;
                        this.orderType = res.data.orderType;
                        this.trackingNo = res.data.trackingNo;
                        this.expressName = res.data.expressName;
                        this.waveId = res.data.waveId;
                        this.platfromVal = res.data.platfromVal;
                        this.isAllocated = res.data.isAllocated;
                        this.materials = res.data.materials;
                        this.multiplematerials = res.data.multiplematerials;
                        this.tempMaterials = false;
                        this.getMaterialList(this.ssccNo);
                        // if(this.totalUnPackedQty < 1){
                        //     this.$nextTick(() => {
                        //         this.$refs.refOrderId.select();
                        //     });
                        // }else {
                        this.$nextTick(() => {
                            if(this.skuInput){
                                this.skuCode = "";
                                this.$refs.refScanSku.focus();
                            }else {
                                this.materialsCode = "";
                                this.$refs.refScanMaterials.focus();
                            }
                        });
                        // }
                        this.getScanPackStatus();
                    }else {
                        this.resetOrder();
                        this.resetCarton();
                        if(this.summaryBtnType){
                            this.searchSummaryList();
                        }
                    }
                    this.handleResize();
                });
            },
            getInstruction(){
                let params = {
                    relId : this.orderId
                }
                ajax.get(api.SCANPACKNEWGETINSTRUCTION, params).then(res => {
                    if (res.code == 200) {
                        this.packingInstruction = res.data.packingInstruction;
                        this.vasInstruction = res.data.vasInstruction;
                    }
                });
            },
            scanSku(){
                if(this.loading){
                    return;
                }
                if(this.skuCode.length < 1 || this.orderItems.length < 1){
                    return;
                }

                if(this.skuCode == 'SWEIGHTS'){
                    this.$nextTick(()=>{
                        this.$refs.refWeight.focus()
                    })
                    this.skuCode = ''
                    return
                }

                if(this.skuCode == 'SCBMS'){
                    this.$nextTick(()=>{
                        this.$refs.refCbm.focus()
                    })
                    this.skuCode = ''
                    return
                }

                if(this.skuCode == 'CLOSECTN'){
                    this.closeCarton();
                    this.skuCode = ''
                    this.$nextTick(()=>{
                        this.$refs.refCbm.focus()
                    })
                    return;
                }

                if(this.skuCode.startsWith("CT_")){
                    this.createCarton(false,false);
                    let cartonTypeLen = this.skuCode.split("_").length;
                    let cartonTypeValue = cartonTypeLen>1?this.skuCode.split("_")[1]:"";
                    for(let t in this.systemParam.CARTON_MASTER_LIST){
                        if(cartonTypeValue === this.systemParam.CARTON_MASTER_LIST[t].cartonType){
                            this.skuCode = '';
                            this.cartonForm.setFieldsValue({"cartonType":cartonTypeValue});
                            this.cartonTypeChange(cartonTypeValue);
                            return;
                        }
                    }
                }

                if(this.skuCode.startsWith("PS_")){
                    let deskNumber = this.skuCode.substring(3,this.skuCode.length);
                    this.skuCode = '';
                    this.cartonForm.setFieldsValue({"userdefined1":deskNumber});
                    this.cartonData.userdefined1 = deskNumber;
                    return;
                }

                if(this.skuCode.toUpperCase() == "CHECKCOMPLETE"){
                    this.checkPartialPack();
                    this.skuCode = '';
                    return;
                }

                if(!this.materials){
                    for(let item of this.materialsCodeList){
                        if(this.skuCode == item.code){
                            this.tempMaterials = true;
                            if(this.ssccNo.length < 1){
                                this.createCarton(false,true);
                            }else{
                                this.createOrDeleteMaterial();
                            }
                            return;
                        }
                    }
                }

                if(!this.cartonScanBtnType && !this.traceIdScanBtnType){
                    let skuExist = false;
                    for (let item of this.orderItems) {
                        if(this.systemParam.SYS_SCAN_BARCODE == "Y"){
                            if ((!this.scanRemoveMode && item.packedQty < item.pickedQty) || (this.scanRemoveMode && item.packedQty > 0)) {
                                if(item.skuCode == this.skuCode) {
                                    this.audioPubFun(this.$i18n.t('dontInputSkuScanBarcode'));
                                    this.$nextTick(() => {
                                        this.$refs.refScanSku.select();
                                    });
                                    return
                                }else if(item.upc == this.skuCode){
                                    this.currentRelId = item.relId;
                                    this.skuItem = item;
                                    skuExist = true;
                                    break;
                                }else if(this.skuCode.split("|").length == 2){//SKU|Qty
                                    if(item.skuCode == this.skuCode.split("|")[0]){
                                        this.popupQuantity = parseInt(this.skuCode.split("|")[1]);
                                        this.pcsPerScan = parseInt(this.skuCode.split("|")[1]);
                                        this.skuCode = this.skuCode.split("|")[0];
                                        this.currentRelId = item.relId;
                                        this.skuItem = item;
                                        skuExist = true;
                                        break;
                                    }
                                }else if(this.skuCode.split("|").length == 3){//SKU|Qty|PO
                                    if(item.skuCode == this.skuCode.split("|")[0]){
                                        this.popupQuantity = parseInt(this.skuCode.split("|")[1]);
                                        this.pcsPerScan = parseInt(this.skuCode.split("|")[1]);
                                        this.poNo = this.skuCode.split("|")[2];
                                        this.skuCode = this.skuCode.split("|")[0];
                                        this.currentRelId = item.relId;
                                        this.skuItem = item;
                                        skuExist = true;
                                        break;
                                    }
                                }else if(this.skuCode.split("%Q").length == 2){//SKU%QQty
                                    if(item.skuCode == this.skuCode.split("%Q")[0]){
                                        this.popupQuantity = parseInt(this.skuCode.split("%Q")[1]);
                                        this.pcsPerScan = parseInt(this.skuCode.split("%Q")[1]);
                                        this.skuCode = this.skuCode.split("%Q")[0];
                                        this.currentRelId = item.relId;
                                        this.skuItem = item;
                                        skuExist = true;
                                        break;
                                    }
                                }else if(this.skuCode.split("%Q").length == 3){//SKU%QQty%QPO
                                    if(item.skuCode == this.skuCode.split("%Q")[0]){
                                        this.popupQuantity = parseInt(this.skuCode.split("%Q")[1]);
                                        this.pcsPerScan = parseInt(this.skuCode.split("%Q")[1]);
                                        this.poNo = this.skuCode.split("%Q")[2];
                                        this.skuCode = this.skuCode.split("%Q")[0];
                                        this.currentRelId = item.relId;
                                        this.skuItem = item;
                                        skuExist = true;
                                        break;
                                    }
                                }
                            }
                        }else{
                            if(item.skuCode == this.skuCode || item.upc == this.skuCode){
                                if ((!this.scanRemoveMode && item.packedQty < item.pickedQty) || (this.scanRemoveMode && item.packedQty > 0)) {
                                    this.currentRelId = item.relId;
                                    this.skuItem = item;
                                    skuExist = true;
                                    break;
                                }
                            }
                        }
                    }
                    if(!skuExist){
                        this.audioPubFun(this.$i18n.t('pubGicSet.InvalidSKU',{"0":this.skuCode}));
                        this.$nextTick(() => {
                            this.$refs.refScanSku.select();
                        });
                        return
                    }
                }

                if(this.manualQtyEntry){
                    this.showEnterQuantity = true;
                    if(this.scanRemoveMode){//Remove
                        this.showEnterQtyTitle = this.$t('removeQuantity');
                        this.showEnterQtyTips = this.$t('piecesToRemove');
                        this.rowBgColor = "bg-red";
                        this.fontColor = "#ED4850";
                        this.btnBgColor = "#E7000B";
                    }else{//Add
                        this.showEnterQtyTitle = this.$t('enterQuantity');
                        this.showEnterQtyTips = this.$t('piecesToAdd');
                        this.rowBgColor = "bg-blue";
                        this.fontColor = "#6A98FC";
                        this.btnBgColor = "#1677FF";
                    }
                    this.$nextTick(() => {
                        this.$refs.refPopQty.select();
                    });
                }else{
                    this.confirmSku();
                }
            },
            confirmSku(){
                if(this.manualQtyEntry){
                    this.pcsPerScan = this.popupQuantity;
                    this.popupQuantity = 1;
                }
                if(this.ssccNo.length < 1){
                    this.createCarton(true,false);
                }else {
                    this.scanningMode();
                }
            },
            scanningMode(removeItem,cache){
                let scanpackWay = this.systemParam.scanpack_way;
                if("Y" == scanpackWay && cache != true){
                    this.scanningSkuCache(removeItem);
                }else {
                    this.submitSku(removeItem);
                }
            },
            scanningSkuCache(removeItem){
                let totalScanQty = 0;
                let totalUnScanQty = 0;
                let currentSkuCode = "";
                if(!removeItem){
                    for (let item of this.orderItems) {
                        if(this.skuCode == item.skuCode || this.skuCode == item.upc){
                            currentSkuCode = item.skuCode;
                            totalScanQty += item.packedQty;
                            totalUnScanQty += item.pickedQty - item.packedQty;
                        }
                    }
                    //Check Qty
                    if(this.scanRemoveMode){//delete
                        if(this.pcsPerScan > totalScanQty){
                            this.audioPubFun(this.$i18n.t('pubGicSet.NotEnoughSkuRemoved',{"0":this.skuCode}));
                            this.$nextTick(() => {
                                this.$refs.refScanSku.select();
                            });
                            return
                        }
                    }else{//add
                        if(this.pcsPerScan > totalUnScanQty){
                            this.audioPubFun(this.$i18n.t('pubGicSet.NotAllowOverPack',{"0":this.skuCode}));
                            this.$nextTick(() => {
                                this.$refs.refScanSku.select();
                            });
                            return
                        }
                    }
                }

                let removeOrderItemQty = 0;
                if(removeItem) {//Click remove icon
                    removeOrderItemQty = removeItem.packedQty;
                    currentSkuCode = removeItem.sku;
                }else if(this.scanRemoveMode){//Scan remove
                    removeOrderItemQty = this.pcsPerScan;
                }
                let removeItemCartonQty = removeOrderItemQty;

                //update Order Items record
                let addOrderItemQty = this.pcsPerScan;
                for (let item of this.orderItems) {
                    if (currentSkuCode == item.skuCode) {
                        if(removeOrderItemQty > 0) {//Remove
                            if(removeOrderItemQty <= item.packedQty){
                                item.packedQty = item.packedQty - removeOrderItemQty;
                                break;
                            }else {
                                removeOrderItemQty = removeOrderItemQty - item.packedQty;
                                item.packedQty = 0;
                            }
                        }else{//Add
                            if(addOrderItemQty <= item.pickedQty - item.packedQty){
                                item.packedQty = item.packedQty + addOrderItemQty;
                                break;
                            }else{
                                addOrderItemQty = addOrderItemQty - (item.pickedQty - item.packedQty);
                                item.packedQty = item.pickedQty;
                            }
                        }
                    }
                }

                //update Items in This Carton record
                let addItemCartonQty = this.pcsPerScan;
                let existSku = false;
                for(let [index,item] of this.itemsInCarton.entries()){
                    if (currentSkuCode == item.sku) {
                        if(removeItemCartonQty > 0) {//Remove
                            item.packedQty -= removeItemCartonQty;
                            if(item.newQty){
                                item.newQty -= removeItemCartonQty;
                            }else{
                                item.newQty =  -removeItemCartonQty;
                            }
                            this.currentCartonQty -= removeItemCartonQty;
                            this.totalPackedQty -= removeItemCartonQty;
                            this.totalUnPackedQty += removeItemCartonQty;
                        }else {//Add
                            item.packedQty += addItemCartonQty;
                            if(item.newQty){
                                item.newQty += addItemCartonQty;
                            }else{
                                item.newQty = addItemCartonQty;
                            }
                            this.currentCartonQty += addItemCartonQty;
                            this.totalPackedQty += addItemCartonQty;
                            this.totalUnPackedQty -= addItemCartonQty;
                        }
                        existSku = true;
                        break;
                    }
                }
                if(!existSku){
                    for (let item of this.orderItems) {
                        if(currentSkuCode == item.skuCode){
                            let newItem={
                                sku : item.skuCode,
                                upc : item.upc,
                                style : item.style,
                                color : item.color,
                                size : item.size,
                                skuDesc : item.skuDesc,
                                packedQty : addItemCartonQty,
                                newQty : addItemCartonQty,
                                packDetailUdf1:this.poNo,
                            };
                            this.poNo = "";
                            this.itemsInCarton.push(newItem);
                            this.currentCartonQty += addItemCartonQty;
                            this.totalPackedQty += addItemCartonQty;
                            this.totalUnPackedQty -= addItemCartonQty;
                            break;
                        }
                    }
                }

                this.scanRemoveMode = false;
                this.pcsPerScan = 1;
                this.popupQuantity = 1;
                this.skuCode = "";
                this.$refs.scanSuccessMusicRef.play();

                if(this.materials){
                    this.resetMaterialScanMode();
                    if(removeItemCartonQty > 0) {
                        for(let item of this.materialsInCarton){
                            item.newQty = -item.qty;
                            item.qty = 0;
                        }
                    }
                }
            },
            submitSku(removeItem){
                this.loading = true;
                let params = {
                    sscc : this.ssccNo,
                    relId : this.currentRelId,
                    waveId: this.waveId,
                    sku : this.skuItem.skuCode,
                    serialNo:"",
                    delete : this.scanRemoveMode,
                    scanPackQty : parseInt(this.pcsPerScan),
                    packDetailUdf1:this.poNo,
                    isHiddenTable:"0"
                };
                if(this.cartonScanBtnType){
                    params.sku = this.skuItem.skuCode;
                    params.isCartonOrPrePack = "isCarton";
                }
                if(this.traceIdScanBtnType){
                    params.sku = this.skuItem.skuCode;
                    params.isCartonOrPrePack = "isTraceId";
                }
                if(removeItem){//Click delete icon
                    params.delete = true;
                    params.sku = removeItem.sku;
                    params.scanPackQty = removeItem.packedQty;
                    if(removeItem.relId){//Packing Summary delete
                        params.relId = removeItem.relId;
                    }else{//Items in This Carton delete
                        if(!params.relId || params.relId.startsWith("Multiple")){
                            for (let item of this.orderItems) {
                                if(item.skuCode == params.sku){
                                    if(item.packedQty > 0){
                                        params.relId = item.relId;
                                        break;
                                    }
                                }
                            }
                        }
                    }
                    if(removeItem.sscc){
                        params.sscc = removeItem.sscc
                    }
                }
                ajax.noLoadingPostAjax(api.SCANPACK, params).then(res=> {
                    if (res.code == 200) {
                        this.cartonUid = res.data.cartonUid;
                        this.scanRemoveMode = false;
                        this.pcsPerScan = 1;
                        this.popupQuantity = 1;
                        this.$refs.scanSuccessMusicRef.play();
                        this.searchOrder();
                        this.searchItemsInCarton();
                        this.searchSummaryList();
                        if(this.materials || this.tempMaterials){
                            if(params.delete){
                                let listDto = [];
                                let dto = {
                                    sscc : params.sscc,
                                    delete : true
                                };
                                listDto.push(dto);
                                this.saveMaterials(listDto);
                            }
                        }
                    }else{
                        this.audioPubFun(res.msg);
                        this.$nextTick(() => {
                            if(this.$refs.refScanSku){
                                this.$refs.refScanSku.focus();
                            }
                        });
                    }
                    this.skuCode = "";
                    this.poNo = "";
                    this.loading = false;
                });
            },
            resetCarton(){
                this.ssccNo = "";
                this.currentCarton = "";
                this.cartonStatus = 'open';
                this.itemsInCarton = [];
                this.materialsInCarton = [];
                this.currentCartonQty = 0;
                this.cartonUid = "";
                this.cartonForm.resetFields();
                this.$nextTick(()=>{
                    this.cartonForm.setFieldsValue({"grossWeight": undefined});
                });
                this.cartonData = {};
                this.scanPackDtoList = [];
            },
            searchItemsInCarton(){
                if(this.ssccNo.length < 1){
                    return;
                }
                let params = {
                    sscc : this.ssccNo
                }
                ajax.get(api.SCANPACKNEWGETITEMSINTHISCARTON, params).then(res => {
                    if (res.code == 200) {
                        let countQty = 0;
                        this.itemsInCarton = res.data;
                        if(this.itemsInCarton.length > 0){
                            this.currentCarton = this.itemsInCarton[0].cartonNo;
                            for (let item of this.itemsInCarton) {
                                countQty += item.packedQty;
                            }
                        }else {
                            this.resetCarton();
                        }
                        this.currentCartonQty = countQty;
                    }
                });
            },
            createCarton(scanPack,createMaterial){
                if(this.currentRelId.length < 1 && this.waveId.length < 1){
                    return;
                }
                this.resetCarton();
                let params = {};
                if(this.currentRelId){
                    params.relId = this.currentRelId
                }else if(this.waveId){
                    params.waveId = this.waveId
                }
                ajax.post(api.SAVECARTON, params).then(res => {
                    if (res.code == 200) {
                        this.ssccNo = res.data.sscc
                        this.cartonForm.setFieldsValue({"cartonType":res.data.cartonType});
                        this.cartonTypeChange(res.data.cartonType);
                        if(scanPack){
                            this.scanningMode();
                        }
                        if(createMaterial){
                            this.createOrDeleteMaterial();
                        }
                    }
                });
            },
            createOrDeleteMaterial(){
                let nextMaterial;
                for(let item of this.materialsCodeList){
                    if(this.skuCode == item.code){
                        if(item.type.split("|").length == 2){
                            nextMaterial = item.type.split("|")[1]
                        }
                        break;
                    }
                }
                let nextMaterialObj;
                if(nextMaterial){
                    for(let item of this.materialsCodeList){
                        if(nextMaterial == item.code){
                            nextMaterialObj = item;
                            break;
                        }
                    }
                }
                let removeQty = 0;
                if(this.scanRemoveMode){
                    removeQty = 1;
                }
                let scanpackWay = this.systemParam.scanpack_way;
                if("Y" == scanpackWay){
                    this.scanningMaterialCache(this.skuCode,removeQty,nextMaterialObj);
                }else {
                    this.scanningMaterialNonCache(this.skuCode,removeQty,nextMaterial);
                }
                this.scanRemoveMode = false;
                this.skuCode = "";
            },
            deleteCarton(){
                let params = {};
                if(this.currentRelId){
                    params.relId = this.currentRelId
                }else if(this.waveId){
                    params.waveId = this.waveId
                }
                params.sscc = this.ssccNo
                if(params.sscc.length < 1){
                    return;
                }
                ajax.post(api.REMOVESCANPACK, params).then(res => {
                    if (res.code == 200) {
                        this.searchOrder();
                        this.resetCarton();
                        if(this.materials || this.tempMaterials){
                            let listDto = [];
                            let dto = {
                                sscc : params.sscc,
                                delete : true
                            };
                            listDto.push(dto);
                            this.saveMaterials(listDto);
                        }
                    }else{
                        this.$customMessage.error(res.msg);
                    }
                });
            },
            closeCarton(){
                if(this.ssccNo.length < 1 || this.itemsInCarton.length === 0){
                    return;
                }
                if(this.materials || this.multiplematerials){
                    let countQty = 0;
                    for(let item of this.itemsInCarton){
                        countQty += item.packedQty;
                    }
                    let innerQty = 0;
                    let outerQty = 0;
                    for(let item of this.materialsInCarton){
                        if(item.type.startsWith("INNER")){
                            innerQty += item.qty;
                        }
                        if(item.type === "OUTER"){
                            outerQty += item.qty;
                        }
                    }
                    if(outerQty == 0){
                        this.$customMessage.error(this.$t('outerQtyAtLeastOne'));
                        return;
                    }
                    if(countQty != innerQty){
                        this.$customMessage.error(this.$t('innerQtyMustEqualPackQty'));
                        return;
                    }
                }
                this.cartonForm.validateFields((err, values) => {
                    if (!err) {
                        let params = values;
                        params.sscc = this.ssccNo
                        if(this.currentRelId){
                            params.relId = this.currentRelId
                        }else if(this.waveId){
                            params.waveId = this.waveId
                        }
                        params.cartonNo = this.currentCarton;
                        params.cartonUid = this.cartonUid;
                        params.dimensionUom = this.cartonData.dimensionUom;
                        params.weightUom = this.cartonData.weightUom;
                        if(this.systemParam.scanpack_way == 'Y'){
                            for(let item of this.itemsInCarton){
                                if(item.newQty){
                                    if(!params.relId || params.relId.startsWith("Multiple")){
                                        for (let order of this.orderItems) {
                                            if(order.skuCode == item.sku){
                                                if(order.packedQty > 0){
                                                    params.relId = order.relId;
                                                    break;
                                                }
                                            }
                                        }
                                    }
                                    let obj = {
                                        "cartonUid" : params.cartonUid,
                                        "delete" : false,
                                        "relId" : params.relId,
                                        "scanPackQty" : item.newQty,
                                        "sku" :  item.sku,
                                        "waveId" :  params.waveId,
                                        "packDetailUdf1" :  item.packDetailUdf1,
                                    }
                                    if(item.newQty > 0){
                                        obj.delete = false;
                                    }else if(item.newQty < 0){
                                        obj.delete = true;
                                        obj.scanPackQty = -obj.scanPackQty;
                                    }
                                    this.scanPackDtoList.push(obj);
                                }
                            }
                            params.scanPackDtoList = this.scanPackDtoList;
                        }
                        ajax.post(api.SCANCLOSE, params).then(res => {
                            if (res.code == 200) {
                                if(this.systemParam.scanpack_way == 'Y') {
                                    let listDto = [];
                                    for (let item of this.materialsInCarton) {
                                        if(item.newQty){
                                            let isDelete = false;
                                            let qty = item.newQty;
                                            if(qty < 0){
                                                isDelete = true;
                                                qty = -qty;
                                            }
                                            let dto = {
                                                waveId : this.waveId,
                                                relId : this.currentRelId,
                                                sscc : this.ssccNo,
                                                delete : isDelete,
                                                sku : item.code,
                                                qty : qty
                                            };
                                            listDto.push(dto);
                                        }
                                    }
                                    this.saveMaterials(listDto);
                                }
                                this.cartonStatus = this.$t('closed');

                                //Auto Print
                                this.printCloseCtnReport();

                                if(this.materials){
                                    this.printWaybillPdfBySO(this.currentRelId);
                                    this.checkPartialPack();
                                }else if(this.tempMaterials){
                                    this.printWaybillPdfBySO(this.currentRelId);
                                }else {
                                    this.currentRelId = "";
                                }

                                this.resetPieceScanMode();
                                this.resetCarton();
                                this.searchOrder();
                            }else{
                                this.scanPackDtoList = [];
                                this.$customMessage.error(res.msg);
                            }
                        });
                    }
                });
            },
            openCarton(item){
                let params = {
                    sscc : item.sscc
                };
                ajax.post(api.APPENDSCAN, params).then(res => {
                    if (res.code == 200) {
                        this.packBtnType = true;
                        this.summaryBtnType = false;
                        this.showPack = true;
                        this.resetCarton();
                        this.ssccNo = item.sscc;
                        this.cartonUid = item.cartonUid;
                        this.searchOrder();
                        this.searchCarton();
                        this.searchItemsInCarton();
                        this.currentRelId = item.relId;
                    }else{
                        this.$customMessage.error(res.msg);
                    }
                    this.handleResize();
                });
            },
            searchCarton(){
                if(this.ssccNo.length < 1){
                    return;
                }
                let params = {
                    sscc : this.ssccNo
                }
                ajax.get(api.SCANPACKNEWSEARCHCARTON, params).then(res => {
                    if (res.code == 200) {
                        this.cartonData = res.data;
                        this.cartonUid = res.data.uid;
                        this.cartonForm.setFieldsValue({"grossWeight": res.data.grossWeight});
                    }
                });
            },
            searchSummaryList(){
                if(this.orderId.length < 1 && this.searchSsccSku.length < 1){
                    this.summaryData = [];
                    return;
                }
                this.showOutstandingData = false;
                let params = {
                    orderNo : this.orderId
                }
                if(this.searchSsccSku.length > 0){
                    params.sscc = this.searchSsccSku
                }else {
                    if(this.orderId.length < 1){
                        return;
                    }
                }
                ajax.get(api.SCANPACKNEWSEARCHSUMMARY, params).then(res => {
                    if (res.code == 200) {
                        this.summaryData = res.data;
                    }
                });
            },
            cartonTypeChange(val){
                let cartonTypeList =  this.systemParam.CARTON_MASTER_LIST;
                let newCartypeCbmJs = this.systemParam.CBM
                cartonTypeList.forEach((item, index) => {
                    if(item.cartonType == val){
                        this.cartonData.length = item.length;
                        this.cartonData.width = item.width;
                        this.cartonData.height = item.height;
                        this.cartonData.dimensionUom = item.dimensionUom;
                        this.cartonData.weightUom = item.weightUom;
                        let uom = 1;
                        if(this.cartonData.dimensionUom == null){
                            uom=1;
                        }else if(this.cartonData.dimensionUom == 'm' || this.cartonData.dimensionUom == 'M'){
                            uom=1;
                        }else if(this.cartonData.dimensionUom == 'dm' || this.cartonData.dimensionUom == 'DM'){
                            uom=10;
                        }else if(this.cartonData.dimensionUom == 'cm' || this.cartonData.dimensionUom == 'CM'){
                            uom=100;
                        }
                        let cbm = (this.cartonData.length / uom)*(this.cartonData.width / uom)*(this.cartonData.height / uom)
                        if(newCartypeCbmJs == null){
                            this.cartonData.cbm = cbm
                        }else{
                            this.cartonData.cbm = this.pub_decimaltoFixed(cbm,newCartypeCbmJs)
                        }
                    }
                });
                this.$nextTick(() => {
                    if(this.$refs.refScanSku){
                        this.$refs.refScanSku.focus();
                    }else if(this.$refs.refScanMaterials){
                        this.$refs.refScanMaterials.focus();
                    }
                });
            },
            pub_decimaltoFixed(params,num) {
                let newpar = parseFloat(params);
                let reg = /^[0-9]+.?[0-9]*$/;
                if(reg.test(newpar)){
                    let newNum = newpar.toFixed(num);
                    return newNum
                }else{
                    return
                }
            },
            getScanPackStatus(){
                if(!this.orderId){
                    return;
                }else{
                    let params = {
                        relId : this.orderId
                    };
                    let that = this;
                    ajax.post(api.SCANPACKGETSCANPACKSTAUS,params).then(res=>{
                        if(res.code == 200){
                            this.checkCompleteDisable = res.checkCompleteDisable;
                            this.cancelCheckCompleteDisable = res.cancelCheckCompleteDisable;
                            this.confirmDisable = res.confirmDisable;
                            this.importScanningFileDisable = res.importScanningFileDisable;
                        }else{
                            that.$customMessage.warning(res.msg);
                        }
                    })
                }
            },
            checkCompleteShowMoveWindow(val){
                this.showCompleteTips = false;
                this.checkComplete(val);
            },
            checkPartialPack(){
                let params = {}
                if(this.currentRelId){
                    params.relId = this.currentRelId
                }else if(this.waveId){
                    params.waveId = this.waveId
                }
                ajax.post(api.CHECKPARTIALPACK,params).then(res=>{
                    if(res.code == 200){
                        let partialPack = res.data;
                        if(res.data != null && typeof res.data == 'object'){
                            partialPack = res.data.partialPack;
                        }
                        if(partialPack){
                            this.showCompleteTips = true;
                        }else {
                            this.checkComplete(false);
                        }
                    }else{
                        this.audioPubFun(res.msg);
                    }
                })
            },
            checkComplete(partialPack){
                let params = {}
                if(this.currentRelId){
                    params.relId = this.currentRelId
                }else if(this.waveId){
                    params.waveId = this.waveId
                }
                params.partialPack = partialPack;
                this.checkCompleteDisable = true;
                ajax.post(api.EXTENDERDEALL,params).then(async res=> {
                    this.checkCompleteDisable = false;
                    if (res.code == 200) {
                        let printRelId = params.relId;
                        let printWaveId = params.waveId;
                        this.currentRelId = "";
                        this.waveId = "";
                        this.searchOrder()
                        let data = res.data;
                        if (res.tips != null && res.tips != "") {
                            this.$customMessage.warning(res.tips);
                        }
                        if (res.warning != null&&res.warning != "") {
                            this.$customMessage.warning(res.warning);
                        } else {
                            this.$message.success(res.msg);
                        }
                        if(partialPack == true && res.partialPack != undefined){
                            this.$refs.adjustMove.show2(res.partialPack,true)
                        }
                        try {
                            await this.getPrinters();
                        } catch (error) {
                            console.error("Get printer failed:", error.message);
                            this.printers = [];
                        }
                        if(printRelId){
                            params = {}
                            params.relId = printRelId;
                            params.ip = this.ip;
                            await ajax.get(api.AUTOPRINTPDF,params).then(res => {
                                this.autoPrint(res);
                            })
                        }
                        if(printRelId || this.waveId){
                            params = {
                                relId: printRelId,
                                ip: this.ip
                            };
                            params.waveId=printWaveId;
                            await ajax.get(api.AUTOPRINTCHECKCOMPLETE,params).then(res => {
                                this.autoPrint(res);
                            })
                        }
                    }else {
                        if (res.warning != null && res.warning != '') {
                            this.$customMessage.warning(res.warning);
                        }
                        this.$customMessage.warning(res.msg);
                    }
                });
            },
            shipConfirm(){
                let paramsData = [];
                if(this.currentRelId){
                    paramsData.push({key: 'moduleName', value: 'SCAN_PACK_VSO'})
                    paramsData.push({key: 'soWaveId', value: this.currentRelId})
                }else if(this.waveId){
                    paramsData.push({key: 'moduleName', value: 'SCAN_PACK_WAVE_HEADER'})
                    paramsData.push({key: 'soWaveId', value: this.waveId})
                }
                let tt = {
                    behrUid: '',
                    fieldMapUid: '',
                    functionUid: '',
                    gmcUid: '',
                    language: this.lang,
                    params: paramsData,
                    type: '',
                }
                if(this.systemParam.DELIVERY_DATE_NOT_PROMPT == 'Y'){
                    let that = this;
                    this.$customConfirm({
                        title: that.$t('publicLang.ConfirmShipment'),
                        okText: that.$t('publicLang.Confirm'),
                        cancelText: that.$t('publicLang.Cancel'),
                        content: "",
                        onOk() {
                            ajax.post(api.SOEXTENDERCONFORM,tt).then(res=>{
                                if(res.code == 200){
                                    that.searchOrder();
                                    that.$message.success(res.msg, 3);
                                }else{
                                    that.$customMessage.warning(res.msg);
                                }
                            })
                        }
                    });
                }else{
                    this.$refs.deliveryDate.show(tt)
                }
            },
            cancelCheckComplete(handleType){
                this.cancelCheckCompleteRequestDisable = true;
                let params = {}
                if(this.currentRelId){
                    params.relId = this.currentRelId
                }else if(this.waveId){
                    params.waveId = this.waveId
                }
                params.handleType = handleType;
                let that = this;
                if(this.systemParam.REMOVE_PICK_DATA_DIALOG == 'Y') {
                    this.$customConfirm({
                        title: that.$t('scanPack.deletePickingData'),
                        okText: that.$t('scanPack.cancelCheckCompleteYes'),
                        cancelText: that.$t('scanPack.cancelCheckCompleteNo'),
                        onOk() {
                            params.deletePickAmr = 'Y';
                            that.postCancelCheckComplete(params,handleType);
                        },
                        onCancel() {
                            that.postCancelCheckComplete(params,handleType);
                        }
                    })
                } else {
                    this.postCancelCheckComplete(params,handleType);
                }
            },
            postCancelCheckComplete(params,handleType) {
                ajax.post(api.CANCELCHECKCOMPLETE,params).then(res=>{
                    this.cancelCheckCompleteRequestDisable = false;
                    this.cancelPartCheckCompleteVisibel = false;
                    if(res.code == 200){
                        if (res.warning != null&&res.warning != "") {
                            this.$customMessage.warning(res.warning);
                        }
                        if("N" == handleType){
                            this.cancelCheckCompleteVisible = false
                            this.$message.success(res.msg);
                        }else {
                            this.cancelCheckCompleteMoveVisibel = false
                            if("Y-N" == handleType){
                                this.$message.success(res.msg);
                            }else{
                                let uid =  res.data
                                this.$refs.adjustMove.show2(uid,true)
                            }
                        }
                        this.searchOrder()
                    }else{
                        this.$customMessage.warning(res.msg);
                        this.cancelCheckCompleteMoveVisibel = false
                        this.cancelCheckCompleteVisible = false
                    }
                })
            },
            cancelPartCheckComplete(){
                let params = {}
                if(this.currentRelId){
                    params.relId = this.currentRelId
                }else if(this.waveId){
                    params.waveId = this.waveId
                }
                params.handleType = 'N';
                ajax.post(api.CANCELCHECKCOMPLETE,params).then(res=>{
                    if(res.code == 200){
                        if (res.warning != null&&res.warning != "") {
                            this.$customMessage.warning(res.warning);
                            return;
                        }
                        this.cancelPartCheckCompleteVisibel = false;
                        this.$message.success(res.msg);
                    }else{
                        this.$customMessage.warning(res.msg);
                    }
                })
            },
            getMaterialList(sscc){
                if(!sscc){
                    this.resetPieceScanMode();
                    return;
                }
                let params = {
                    sscc : sscc
                };
                ajax.get(api.SCANPACKNEWGETMATERIALLIST, params).then(res => {
                    if (res.code == 200) {
                        this.materialsInCarton = res.data;
                        let type = new Set();
                        let pcs = 0;
                        for (let item of this.materialsInCarton) {
                            if(item.qty > 0){
                                type.add(item.type);
                                pcs += item.qty;
                            }
                            if(item.type.split("|").length == 2){
                                item.type = item.type.split("|")[0];
                            }
                        }
                        this.materialsInCartonPcs = pcs;
                        if(pcs > 0 && !this.materials){
                            this.tempMaterials = true;
                            this.handleResize();
                        }
                        if(type.size == 2){
                            this.$nextTick(()=>{
                                if(this.materials){
                                    this.$refs.refWeight.focus()
                                }else if(this.tempMaterials){
                                    this.$refs.refScanSku.focus()
                                }
                            })
                        }else{
                            if(!this.ssccNo){
                                this.resetPieceScanMode();
                            }else {
                                if(this.materials){
                                    this.resetMaterialScanMode();
                                }
                            }
                        }
                    }else{
                        this.materialsInCarton = [];
                    }
                });
            },
            getMaterials(){
                ajax.get(api.SCANPACKNEWGETMATERIALS,null).then(res => {
                    if (res.code == 200) {
                        this.materialsCodeList = res.data;
                    }
                });
            },
            scanMaterials(removeItem){
                let currentCode = this.materialsCode;
                if(currentCode == 'SWEIGHTS'){
                    this.$nextTick(()=>{
                        this.$refs.refWeight.focus()
                    })
                    this.materialsCode = ''
                    return
                }

                if(currentCode == 'SCBMS'){
                    this.$nextTick(()=>{
                        this.$refs.refCbm.focus()
                    })
                    this.materialsCode = ''
                    return
                }

                if(currentCode == 'CLOSECTN'){
                    this.closeCarton();
                    this.materialsCode = ''
                    this.$nextTick(()=>{
                        this.$refs.refCbm.focus()
                    })
                    return;
                }

                if(currentCode.startsWith("CT_")){
                    this.createCarton(false,false);
                    let cartonTypeLen = currentCode.split("_").length;
                    let cartonTypeValue = cartonTypeLen>1?currentCode.split("_")[1]:"";
                    for(let t in this.systemParam.CARTON_MASTER_LIST){
                        if(cartonTypeValue === this.systemParam.CARTON_MASTER_LIST[t].cartonType){
                            this.materialsCode = '';
                            this.cartonForm.setFieldsValue({"cartonType":cartonTypeValue});
                            this.cartonTypeChange(cartonTypeValue);
                            return;
                        }
                    }
                }

                if(currentCode.startsWith("PS_")){
                    let deskNumber = currentCode.substring(3,currentCode.length);
                    this.materialsCode = '';
                    this.cartonForm.setFieldsValue({"userdefined1":deskNumber});
                    this.cartonData.userdefined1 = deskNumber;
                    return;
                }

                if(currentCode.toUpperCase() == "CHECKCOMPLETE"){
                    this.checkPartialPack();
                    this.materialsCode = '';
                    return;
                }

                let removeQty = 0;
                if(removeItem) {//Click remove icon
                    removeQty = removeItem.qty;
                    currentCode = removeItem.code;
                }else if(this.scanRemoveMode){//Scan remove
                    removeQty = 1;
                }
                let checkMaterial = false;
                let nextMaterial;
                for(let item of this.materialsCodeList){
                    if(currentCode == item.code){
                        checkMaterial = true;
                        if(item.type.split("|").length == 2){
                            nextMaterial = item.type.split("|")[1]
                        }
                        break;
                    }
                }
                if(!checkMaterial){
                    this.audioPubFun(this.$i18n.t('notFoundMaterial')+this.materialsCode);
                    this.$nextTick(() => {
                        this.$refs.refScanMaterials.select();
                    });
                    return;
                }
                let nextMaterialObj;
                if(nextMaterial){
                    checkMaterial = false;
                    for(let item of this.materialsCodeList){
                        if(nextMaterial == item.code){
                            checkMaterial = true;
                            nextMaterialObj = item;
                            break;
                        }
                    }
                    if(!checkMaterial){
                        this.audioPubFun(this.$i18n.t('notFoundMaterial')+nextMaterial);
                        this.$nextTick(() => {
                            this.$refs.refScanMaterials.select();
                        });
                        return;
                    }
                }
                let that = this;
                let doScanMaterial = function(){
                    let scanpackWay = that.systemParam.scanpack_way;
                    if("Y" == scanpackWay){
                        that.scanningMaterialCache(currentCode,removeQty,nextMaterialObj);
                    }else {
                        that.scanningMaterialNonCache(currentCode,removeQty,nextMaterial);
                    }
                };
                if(removeQty > 0){
                    doScanMaterial();
                }else{
                    if(this.itemsInCarton.length > 0){
                        let currentSku = this.itemsInCarton[0].sku;
                        let params = {
                            waveId : this.waveId,
                            sku : currentSku,
                            material : currentCode
                        };
                        ajax.get(api.SCANPACKNEWCHECKMATERIALS, params).then(res => {
                            if (res.code == 200) {
                                doScanMaterial();
                            } else {
                                that.$customConfirm({
                                    title: res.msg,
                                    okText: that.$t('scanPack.cancelCheckCompleteYes'),
                                    cancelText: that.$t('scanPack.cancelCheckCompleteNo'),
                                    onOk() {
                                        doScanMaterial();
                                    }
                                });
                            }
                        });
                    }
                }
            },
            scanningMaterialNonCache(currentCode,removeQty,nextMaterial){
                let listDto = [];
                let isDelete = false;
                let qty = 1;
                if(removeQty > 0){
                    isDelete = true;
                    qty = removeQty;
                }
                let dto = {
                    waveId : this.waveId,
                    relId : this.currentRelId,
                    sscc : this.ssccNo,
                    delete : isDelete,
                    sku : currentCode,
                    qty : qty
                };
                listDto.push(dto);
                if(nextMaterial && !isDelete){
                    let nextDto = {...dto};
                    nextDto.sku = nextMaterial;
                    listDto.push(nextDto);
                }
                this.saveMaterials(listDto);
            },
            scanningMaterialCache(currentCode,removeQty,nextMaterialObj){
                let existMaterial = false;
                for(let item of this.materialsInCarton){
                    if(currentCode === item.code){
                        if(removeQty > 0){
                            item.qty -= removeQty;
                            if(item.newQty){
                                item.newQty -= removeQty;
                            }else{
                                item.newQty = -removeQty;
                            }
                        }else{
                            item.qty ++;
                            if(item.newQty){
                                item.newQty += 1;
                            }else{
                                item.newQty = 1;
                            }
                        }
                        existMaterial = true;
                        break;
                    }
                }
                if(!existMaterial && removeQty == 0){
                    for(let item of this.materialsCodeList){
                        if(currentCode === item.code){
                            let newObj = {
                                type : item.type,
                                code : item.code,
                                name : item.name,
                                newQty :1,
                                qty : 1
                            }
                            this.materialsInCarton.push(newObj);
                            break;
                        }
                    }
                }
                if(nextMaterialObj){
                    let existMaterial = false;
                    for(let item of this.materialsInCarton){
                        if(nextMaterialObj.code === item.code) {
                            if(removeQty > 0) {
                                if(item.qty >= removeQty){
                                    item.qty -= removeQty;
                                    if(item.newQty){
                                        item.newQty -= removeQty;
                                    }else{
                                        item.newQty = -removeQty;
                                    }
                                }
                            }else {
                                item.qty ++;
                                if(item.newQty){
                                    item.newQty += 1;
                                }else{
                                    item.newQty = 1;
                                }
                            }
                            existMaterial = true;
                            break;
                        }
                    }
                    if(!existMaterial && removeQty == 0){
                        for(let item of this.materialsCodeList) {
                            if (nextMaterialObj.code === item.code) {
                                let newObj = {
                                    type : nextMaterialObj.type,
                                    code : nextMaterialObj.code,
                                    name : nextMaterialObj.name,
                                    newQty : 1,
                                    qty : 1,
                                }
                                this.materialsInCarton.push(newObj);
                                break;
                            }
                        }
                    }
                    this.handleResize();
                }
                let type = new Set();
                let pcs = 0;
                for (let item of this.materialsInCarton) {
                    if(item.qty > 0){
                        type.add(item.type);
                        pcs += item.qty;
                    }
                    if(item.type.split("|").length == 2){
                        item.type = item.type.split("|")[0];
                    }
                }
                this.materialsInCartonPcs = pcs;
                if(type.size == 2){
                    if(this.cartonStatus == 'open'){
                        this.$nextTick(()=>{
                            if(this.materials){
                                this.$refs.refWeight.focus()
                            }else if(this.tempMaterials){
                                this.$refs.refScanSku.focus()
                            }
                        })
                    }
                }else{
                    if(!this.ssccNo){
                        this.resetPieceScanMode();
                    }else {
                        if(this.materials){
                            this.resetMaterialScanMode();
                        }
                    }
                }
                this.scanRemoveMode = false;
                this.pcsPerScan = 1;
                this.materialsCode = "";
                this.$refs.scanSuccessMusicRef.play();
            },
            saveMaterials(list){
                if(!list){
                    return;
                }
                ajax.post(api.SCANPACKNEWSAVEMATERIALS, list).then(res => {
                    if (res.code == 200) {
                        this.$refs.scanSuccessMusicRef.play();
                        this.materialsCode = "";
                        this.skuCode = "";
                        this.scanRemoveMode = false;
                        this.getMaterialList(this.ssccNo);
                    }else{
                        this.$customMessage.error(res.msg);
                    }
                });
            },
            scanWeight(){
                if(this.ssccNo.length == 0 || this.itemsInCarton.length == 0 || this.cartonStatus != 'open' || !this.materials){
                    this.$nextTick(()=>{
                        this.$refs.refScanSku.focus()
                    })
                }else{
                    this.closeCarton();
                }
            },
            getSysConfig(){
                this.btnFunArr = [
                    {code: 'Intersoft',arr:[]},
                    {code: 'AfterShip',arr:[]},
                    {code: 'DHL',arr:[]},
                    {code: 'Others',arr:[]},
                    {code: 'Print',arr:[]},
                ];
                ajax.get(api.GENERICPRINTNODEALLBTNFORLOAD,{module_code:"SCAN_PACK_NEW"}).then(res=>{
                    if (res.code == 200) {
                        let fieldMap = res.data.fieldMap;
                        if(fieldMap.pcUserdefined1){
                            let item = {
                                code : 'userdefined1',
                                name : fieldMap.pcUserdefined1.displayName
                            };
                            this.scanPackUdf.push(item);
                        }
                        if(fieldMap.pcUserdefined2){
                            let item = {
                                code : 'userdefined2',
                                name : fieldMap.pcUserdefined2.displayName
                            };
                            this.scanPackUdf.push(item);
                        }
                        if(fieldMap.pcUserdefined3){
                            let item = {
                                code : 'userdefined3',
                                name : fieldMap.pcUserdefined3.displayName
                            };
                            this.scanPackUdf.push(item);
                        }
                        if(fieldMap.pcUserdefined4){
                            let item = {
                                code : 'userdefined4',
                                name : fieldMap.pcUserdefined4.displayName
                            };
                            this.scanPackUdf.push(item);
                        }
                        if(fieldMap.pcUserdefined5){
                            let item = {
                                code : 'userdefined5',
                                name : fieldMap.pcUserdefined5.displayName
                            };
                            this.scanPackUdf.push(item);
                        }
                        this.handleResize();

                        let btnMap = res.data.behrMap;
                        if (btnMap != null ) {
                            for (let key in  btnMap) {
                                if (btnMap[key] !== null) {
                                    for(let i in this.btnFunArr){
                                        if(this.btnFunArr[i].code == key){
                                            this.btnFunArr[i].arr = btnMap[key];
                                        }
                                    }
                                }
                            }

                            if(btnMap.Print){
                                let prints = btnMap.Print;
                                if(prints[0].gmcUid){
                                    this.gmcUid = prints[0].gmcUid;
                                    this.getAutoPrintLabel(prints[0].gmcUid);
                                }
                            }
                        }
                    }
                });
            },
            exportSummary(){
                let params = {
                    orderId : this.orderId,
                    sscc : this.searchSsccSku
                };
                ajax.exportExcel(ajax.ajaxUrl() + api.SCANPACKNEWEXPORTSUMMARY, params).then(data=>{
                    this.$store.commit("updataLoading", { pbLoading: false });
                    if (!data) {
                        return;
                    }
                    var blob = new Blob([data.data], {
                        type:
                            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8"
                    });
                    var url = window.URL.createObjectURL(blob);
                    var aLink = document.createElement("a");
                    aLink.style.display = "none";
                    aLink.href = url;
                    aLink.setAttribute("download", "PackingSummary.xlsx");
                    document.body.appendChild(aLink);
                    aLink.click();
                    document.body.removeChild(aLink); //下载完成移除元素
                    window.URL.revokeObjectURL(url); //释放掉blob对象
                })
            },
            printPDFByBtnConfig(btnConfig){
                let btnName = btnConfig.name;
                if(btnName == 'Intersoft Generate Label'){
                    this.GenerateLabel('pack_list');
                }else if(btnName == 'Intersoft Cancel Label'){
                    this.IntersoftCancelLabel('pack_list')
                }else if(btnName == 'Intersoft Generate Manifest'){
                    this.IntersoftGenerateMainfest('pack_list')
                }else if(btnName == 'AfterShip Generate Label') {
                    this.printAfterShipGenerateLabel('Courier Edi')
                }else if(btnName == 'AfterShip Cancel Label') {
                    this.printAfterShipCancelLabel('Courier Edi');
                }else if(btnName == 'AfterShip Generate Manifest') {
                    this.$customMessage.error('System error');
                }else if(btnName == 'DHL Shipment Label') {
                    this.printDHLShipmentLabel('Courier Edi')
                }else if(btnName == 'DHL Return Label') {
                    this.printDHLReturnLabel('Courier Edi')
                }else if(btnName == 'printPDF') {
                    this.printPDF()
                }else if(btnName == 'Review PDF') {
                    this.printShippingLabel()
                }else if(btnName == 'Print PDF By Wave(Auto Print)') {
                    this.printWaybillPdfByWave()
                }else if(btnName == 'Print PDF By Wave(Auto Print)2') {
                    this.previewWaybillPdfByWave(1)
                }else if(btnName == 'Preview PDF By Wave') {
                    this.previewWaybillPdfByWave(2)
                }else if(btnName == 'Print PDF By Wave') {
                    this.exportWaybillPdfByWave()
                }else if(btnName == 'Print PDF By SO') {
                    this.printWaybillPdfBySO()
                }
                this.showCourier = false;
            },
            GenerateLabel(val){
                let params = {
                    relId: this.orderId
                }
                ajax.post(api.GENERATELABEL,params).then(res=>{
                    if(res.code == 200){
                        window.open(res.msg);
                    }else{
                        this.$customMessage.warning(res.msg);
                    }
                })
            },
            IntersoftCancelLabel(val){
                let params = {
                    relId: this.orderId
                }
                ajax.post(api.CANCELLABEL,params).then(res=>{
                    if(res.code == 200){
                        this.$message.success(res.msg);
                    }else{
                        this.$customMessage.warning(res.msg);
                    }
                })
            },
            IntersoftGenerateMainfest(val){
                let params = {
                    relId: this.orderId
                }
                ajax.post(api.GENERATEMAINFEST,params).then(res=>{
                    if(res.code == 200){
                        window.open(res.msg);
                        this.$message.success("success");
                    }else{
                        this.$customMessage.warning(res.msg);
                    }
                })
            },
            printAfterShipGenerateLabel(type) {
                // 只有当RelId不为Null 又或者 调用是Courier Edi的时候才调用 => 当type为 Check Complete
                if ((this.orderId != undefined && this.orderId != '') || type == 'Courier Edi') {
                    let paramsData = [];
                    let paramsRelId = {};
                    paramsRelId.key = "relId";
                    paramsRelId.value = this.currentRelId,
                        paramsData.push(paramsRelId);

                    // ip
                    let paramsIP = {};
                    paramsIP.key = "IP";
                    paramsIP.value = this.ip;
                    paramsData.push(paramsIP);

                    let tt = {
                        language: this.lang,
                        params: paramsData,
                    }
                    this.getPrinters();
                    ajax.post(api.AFTERSHIPCREATELABEL, tt).then(res => {
                        if (res.code == 200) {
                            if (res.print != undefined && res.print != null && res.print != '') {
                                this.$message.success('success');
                                let printRequest = res.print;
                                this.pushPrinter(printRequest);

                            } else if (res.data != undefined && res.data != '') {
                                this.$message.success('success');
                                let pdfUrl = res.data;
                                this.previewHttpFile(pdfUrl);

                                // 重新查询箱子信息
                                if(this.ssccNo!=undefined &&this.ssccNo!=null&& this.ssccNo!='') {
                                    this.cartonSearchEnter();
                                }

                            } else {
                                if ('Courier Edi' === type) {
                                    // Courier Edi (暂时改动，ServiceType为Null不报错，也不调用ApiRequest)
                                    if (res.msg != undefined && res.msg != '') {
                                        this.$customMessage.error(res.msg);
                                    }
                                }
                            }

                            /*if (res.print) {
                                let printRequest = res.print;
                                this.pushPrinter(printRequest);
                            }*/

                        } else {
                            this.$customMessage.error(res.msg);
                        }
                    });
                }
            },
            printAfterShipCancelLabel(type) {
                // 只有当RelId不为Null 又或者 调用是Courier Edi的时候才调用 => 当type为Cancel Check Complete
                if ((this.orderId != undefined && this.orderId != '') || type == 'Courier Edi') {
                    let paramsData = [];
                    let paramsRelId = {};
                    paramsRelId.key = "relId";
                    paramsRelId.value = this.currentRelId;
                    paramsData.push(paramsRelId);
                    let tt = {
                        language: this.lang,
                        params: paramsData,
                    }
                    ajax.post(api.AFTERSHIPCANCELLABEL, tt).then(res => {
                        if (res.code == 200) {
                            if (res.data != undefined && res.data != '') {
                                this.$message.success(res.data);
                                // 重新查询箱子信息
                                if(this.ssccNo!=undefined &&this.ssccNo!=null&& this.ssccNo!='') {
                                    this.cartonSearchEnter();
                                }

                            } else {
                                if ('Courier Edi' === type) {
                                    this.$customMessage.error(res.msg);
                                }
                            }
                        } else {
                            this.$customMessage.error(res.msg);
                        }
                    });
                }
            },
            printDHLShipmentLabel(type) {
                // 只有当RelId不为Null 又或者 调用是Courier Edi的时候才调用 => 当type为 Check Complete
                if ((this.orderId != undefined && this.orderId != '') || type == 'Courier Edi') {
                    let paramsData = [];
                    let paramsRelId = {};
                    paramsRelId.key = "relId";
                    paramsRelId.value = this.currentRelId,
                        paramsData.push(paramsRelId);

                    // ip
                    let paramsIP = {};
                    paramsIP.key = "IP";
                    paramsIP.value = this.ip;
                    paramsData.push(paramsIP);

                    let tt = {
                        language: this.lang,
                        params: paramsData,
                    }
                    this.getPrinters();
                    ajax.post(api.DHLSHIPMENTLABEL, tt).then(res => {
                        if (res.code == 200) {
                            if (res.print != undefined && res.print != null && res.print != '') {
                                this.$message.success('success');
                                let printRequest = res.print;
                                this.pushPrinter(printRequest);

                            } else if (res.data != undefined && res.data != '') {
                                this.$message.success('success');
                                let pdfUrls = res.data;
                                this.previewHttpFiles(pdfUrls);

                                // 重新查询箱子信息
                                if(this.ssccNo!=undefined &&this.ssccNo!=null&& this.ssccNo!='') {
                                    this.cartonSearchEnter();
                                }

                            } else {
                                if ('Courier Edi' === type) {
                                    // Courier Edi (暂时改动，ServiceType为Null不报错，也不调用ApiRequest)
                                    if (res.msg != undefined && res.msg != '') {
                                        this.$customMessage.error(res.msg);
                                    }
                                }
                            }

                            /*if (res.print) {
                                let printRequest = res.print;
                                this.pushPrinter(printRequest);
                            }*/

                        } else {
                            this.$customMessage.error(res.msg);
                        }
                    });
                }
            },
            printDHLReturnLabel(type) {
                // 只有当RelId不为Null 又或者 调用是Courier Edi的时候才调用 => 当type为 Check Complete
                if ((this.orderId != undefined && this.orderId != '') || type == 'Courier Edi') {
                    let paramsData = [];
                    let paramsRelId = {};
                    paramsRelId.key = "relId";
                    paramsRelId.value = this.currentRelId,
                        paramsData.push(paramsRelId);

                    // ip
                    let paramsIP = {};
                    paramsIP.key = "IP";
                    paramsIP.value = this.ip;
                    paramsData.push(paramsIP);

                    let tt = {
                        language: this.lang,
                        params: paramsData,
                    }
                    this.getPrinters();
                    ajax.post(api.DHLRETURNLABEL, tt).then(res => {
                        if (res.code == 200) {
                            if (res.print != undefined && res.print != null && res.print != '') {
                                this.$message.success('success');
                                let printRequest = res.print;
                                this.pushPrinter(printRequest);

                            } else if (res.data != undefined && res.data != '') {
                                this.$message.success('success');
                                let pdfUrls = res.data;
                                this.previewHttpFiles(pdfUrls);

                                // 重新查询箱子信息
                                if(this.ssccNo!=undefined &&this.ssccNo!=null&& this.ssccNo!='') {
                                    this.cartonSearchEnter();
                                }

                            } else {
                                if ('Courier Edi' === type) {
                                    // Courier Edi (暂时改动，ServiceType为Null不报错，也不调用ApiRequest)
                                    if (res.msg != undefined && res.msg != '') {
                                        this.$customMessage.error(res.msg);
                                    }
                                }
                            }

                            /*if (res.print) {
                                let printRequest = res.print;
                                this.pushPrinter(printRequest);
                            }*/

                        } else {
                            this.$customMessage.error(res.msg);
                        }
                    });
                }
            },
            async printPDF(){
                if (this.orderId == undefined || this.orderId == '') {
                    this.$customMessage.error("Rel Id " + this.$t('job.notNull'));
                    return;
                }
                let params = {
                    relId: this.orderId
                };
                await this.getPrinters();
                await ajax.get(api.AUTOPRINTBASE64,params).then(res => {
                    if(res.code == 200){
                        this.autoPrint(res.data);
                        this.$message.success("Print Success");
                    }else{
                        this.$customMessage.error(res.msg);
                    }
                })
            },
            printShippingLabel(){
                if (this.orderId == undefined || this.orderId == '') {
                    this.$customMessage.error("Rel Id " + this.$t('job.notNull'));
                    return;
                }
                let params = {
                    relId: this.orderId,
                    documentType:"shippingLabel"
                };
                ajax.get(api.GETJELLYCATDOCUMENTPRINTURL,params).then(res => {
                    if(res.code == 200){
                        let ajaxurl = ajax.ajaxUrl();
                        let previewUrl = ajaxurl + "/printViewFile?filePath=" + res.data;
                        window.open(previewUrl, '_blank');
                        this.$message.success("Print Success");
                    }else{
                        this.$customMessage.error(res.msg);
                    }
                })
            },
            async printWaybillPdfByWave(){
                if (this.waveId == undefined || this.waveId == '') {
                    this.$customMessage.error("WaveNo No " + this.$t('job.notNull'));
                    return;
                }
                let params = {
                    waveId: this.waveId
                };
                await this.getPrinters();
                await ajax.get(api.PRINTWAYBILLPDFBYWAVE,params).then(res => {
                    if(res.code == 200){
                        this.autoPrint(res.data);
                        this.$message.success("Print Success");
                    }else{
                        this.$customMessage.error(res.msg);
                    }
                })
            },
            async previewWaybillPdfByWave(type){
                if (this.waveId == undefined || this.waveId == '') {
                    this.$customMessage.error("WaveNo No " + this.$t('job.notNull'));
                    return;
                }
                let params = {
                    waveId: this.waveId,
                    type: type
                };
                await this.getPrinters();
                await ajax.get(api.PREVIEWWAYBILLPDFBYWAVE,params).then(res => {
                    if(res.code == 200){
                        if(type==1){
                            this.autoPrint(res.data);
                        }else if(type==2){
                            let ajaxurl = ajax.ajaxUrl();
                            let previewUrl = ajaxurl + "/printViewFile?filePath=" + res.data;
                            window.open(previewUrl, '_blank');
                        }
                        this.$message.success("Print Success");
                    }else{
                        this.$customMessage.error(res.msg);
                    }
                })
            },
            exportWaybillPdfByWave(){
                if (this.waveId == undefined || this.waveId == '') {
                    this.$customMessage.error("WaveNo No " + this.$t('job.notNull'));
                    return;
                }
                let waveId = this.waveId;
                let ajaxurl = ajax.ajaxUrl();
                let params = {
                    waveId: waveId
                }
                let that = this;
                axios.get(ajaxurl + api.EXPORTWAYBILLPDFBYWAVE, {
                    params ,
                    headers: {
                        Authorization: cookie.getToken()
                    },
                    responseType: "blob" //二进制流
                }).then(function(res) {
                    let resHeader = res.headers;
                    let contentType = resHeader["content-type"];

                    // 定义 ZIP 文件的 Content-Type
                    let zipContentType = "application/zip";
                    let octetStreamType = "application/octet-stream";

                    // 检测是否是 ZIP 文件
                    if (contentType.includes(zipContentType) || contentType.includes(octetStreamType)) {
                        // ZIP 文件处理
                        var data = res;
                        if (!data) {
                            return;
                        }
                        // 修改 Blob 类型为 application/zip
                        var blob = new Blob([data.data], {
                            type: "application/zip"
                        });
                        var url = window.URL.createObjectURL(blob);
                        var aLink = document.createElement("a");
                        aLink.style.display = "none";
                        aLink.href = url;
                        // 设置 ZIP 文件名（可以从响应头获取或自定义）
                        let fileName = waveId+".zip";
                        // 尝试从 Content-Disposition 头获取文件名
                        let contentDisposition = resHeader["content-disposition"];
                        if (contentDisposition) {
                            let fileNameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
                            if (fileNameMatch && fileNameMatch[1]) {
                                fileName = fileNameMatch[1].replace(/['"]/g, '');
                            }
                        }
                        aLink.setAttribute("download", fileName);
                        document.body.appendChild(aLink);
                        aLink.click();
                        document.body.removeChild(aLink); // 下载完成移除元素
                        window.URL.revokeObjectURL(url); // 释放 blob 对象
                    }
                }).catch(function(error) {
                    if (error.response) {
                        let status = error.response.status;
                        if (status === 500) {
                            that.$customMessage.error("Download failed");
                        }else if (status === 501) {
                            that.$customMessage.error("No Data");
                        }else if (status === 503) {
                            that.$customMessage.error("Duplicate operation is not allowed");
                        }
                    }
                })
            },
            async printWaybillPdfBySO(relId){
                if (this.orderId == undefined || this.orderId == '') {
                    this.$customMessage.error("Rel Id " + this.$t('job.notNull'));
                    return;
                }
                let params = {
                    relId: this.orderId
                };
                if(relId){
                    params.relId = relId;
                }
                await this.getPrinters();
                await ajax.get(api.PRINTWAYBILLPDFBYSO,params).then(res => {
                    if(res.code == 200){
                        this.autoPrint(res.data);
                        this.$message.success("Print Success");
                    }else{
                        this.$customMessage.error(res.msg);
                    }
                })
            },
            getPrinters(){
                return new Promise((resolve, reject) => {
                    let that = this;
                    if ("WebSocket" in window)
                    {
                        // Create websocket
                        var ws = new WebSocket("ws://localhost:9999/print");
                        ws.onopen = function()
                        {
                            ws.send("{'Type':'SERVER_INFO'}");
                        };
                        ws.onmessage = function (evt)
                        {
                            var msg = evt.data;
                            try {
                                that.printers = JSON.parse(msg).printerServer.printers;
                                resolve(that.printers); // 获取到数据后 resolve
                                ws.close();
                            } catch (e) {
                            }
                        };
                        ws.onclose = function()
                        {

                        };
                    }
                    else
                    {
                        reject(new Error("WebSocket not supported"));
                    }
                });
            },
            autoPrint(res){
                for (let i = 0; i < res.length; i++) {
                    if(res[i]==null){
                        continue;
                    }
                    if (res[i].type == null) {
                        continue;
                    }
                    if(res[i].errorMsg!=null&&res[i].errorMsg!=""){
                        continue;
                    }
                    if(res[i].printerName==null||res[i].printerName==""){
                        continue;
                    }
                    let printerName = "";
                    let printerNames = res[i].printerName.split(",");
                    for(var j = 0;j<this.printers.length;j++){
                        for(var k = 0;k<printerNames.length;k++){
                            if(this.printers[j].name==printerNames[k]){
                                printerName = printerNames[k];
                                break;
                            }
                        }
                        if(printerName!=""&&printerName!=null){
                            break;
                        }
                    }
                    if(printerName!=""){
                        res[i].printerName = printerName;
                        if(res[i].fileBytes.length>125000){
                            let oldFileBytes = res[i].fileBytes;
                            let part = Math.ceil(oldFileBytes.length/125000);//分批数
                            for (let j = 0; j < part; j++)
                            {
                                let fileBytes = "";
                                if (oldFileBytes.length>125000) {
                                    fileBytes = oldFileBytes.substring(0, 125000);
                                    oldFileBytes = oldFileBytes.substring(125000, oldFileBytes.lenght);
                                } else {
                                    fileBytes = oldFileBytes.substring(0, oldFileBytes.lenght);
                                    oldFileBytes = "";
                                }
                                res[i].fileIndex = j;//当前发送位置
                                res[i].fileCount = part;//表示发送多次已发完
                                res[i].fileBytes = fileBytes;
                                webSocketPrint.doPrint("9999",JSON.stringify(res[i]));
                            }
                        }else{
                            res[i].fileCount = 1;//1表示一次发完
                            webSocketPrint.doPrint("9999",JSON.stringify(res[i]));
                        }
                    }
                }
            },
            getUserIP (onNewIP) {
                let MyPeerConnection = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection
                let pc = new MyPeerConnection({
                    iceServers: []
                })
                let noop = () => {

                }
                let localIPs = {}
                let ipRegex = /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/g
                let iterateIP = (ip) => {
                    if (!localIPs[ip]) onNewIP(ip)
                    localIPs[ip] = true
                }
                pc.createDataChannel('')
                pc.createOffer().then((sdp) => {
                    sdp.sdp.split('\n').forEach(function (line) {
                        if (line.indexOf('candidate') < 0) return
                        line.match(ipRegex).forEach(iterateIP)
                    })
                    pc.setLocalDescription(sdp, noop, noop)
                }).catch((reason) => {
                })
                pc.onicecandidate = (ice) => {
                    if (!ice || !ice.candidate || !ice.candidate.candidate || !ice.candidate.candidate.match(ipRegex)) return
                    ice.candidate.candidate.match(ipRegex).forEach(iterateIP)
                }
            },
            importScanningFile(){
                let relId = this.orderId
                this.$refs.importScanningFile.show(relId);
                return;
            },
            GETcancelImport(val) {
                this.importVisible = false;
                if (val == "init") {
                    this.searchOrder();
                }
            },
            printByBtnConfig(btnConfig){
                if((btnConfig.externalApi == null || btnConfig.externalApi == "") && this.orderId == ""){
                    this.$customMessage.error("Rel Id,Wave Id " + this.$t('job.notNull'));
                    return;
                }
                if( btnConfig.code == "BTN_SAVE" || btnConfig.code == "BTN_EXPORT"){
                    if( btnConfig.code == "BTN_SAVE"){
                        let ajaxurl = ajax.ajaxUrl();
                        this.isBtnajax = true;
                        let that = this
                        let paramsData = [];
                        // 填充信息
                        if(!this.currentRelId){
                            let paramsObj = {};
                            paramsObj.key = "waveId";
                            paramsObj.value = this.waveId;
                            paramsData.push(paramsObj);
                        }else{
                            let paramsObj = {};
                            paramsObj.key = "relId"
                            paramsObj.value =  this.currentRelId;
                            paramsData.push(paramsObj);
                        }
                        let params = {
                            gmcUid: btnConfig.gmcUid,
                            uid: '',
                            btnName: btnConfig.name,
                            btnUid: btnConfig.uid,
                            params: paramsData
                        }
                        if( btnConfig.externalApi == '/cfs/so/printLabelUrl'){
                            axios.post(ajaxurl + btnConfig.externalApi, params).then(data => {
                                if (data.data.code == 200){
                                    let urlStr = data.data.data;
                                    this.soUrl = urlStr.split(",")
                                    if (this.soUrl == null || this.soUrl.length == 0){
                                        this.$message.success("No Data",3);
                                    }
                                    for(let i = 0 ; i < this.soUrl.length ; i++){
                                        window.open(this.soUrl[i]);
                                    }
                                }else {
                                    that.$customMessage.warning(data.data.msg, 3);
                                }
                            });
                        } else if( btnConfig.externalApi == '/outbound/extender/farfetchPrintDocs'){

                            axios.post(ajaxurl + btnConfig.externalApi, params).then(data => {
                                if (data.data.code == 200){
                                    let urlStr = data.data.msg;
                                    this.soUrl = urlStr.split(",")
                                    if (this.soUrl == null || this.soUrl.length == 0){
                                        this.$message.success("No Data",3);
                                    }
                                    for(let i = 0 ; i < this.soUrl.length ; i++){
                                        window.open(this.soUrl[i]);
                                    }
                                }else {
                                    that.$customMessage.warning(data.data.msg, 3);
                                }
                            });
                        } else if( btnConfig.externalApi == '/outbound/extender/printDhlLabelWPX'){
                            axios.post(ajaxurl + btnConfig.externalApi, params).then(res => {
                                if (res.data.code == 200) {
                                    // URLs
                                    let urlStr =  res.data.data.urls;
                                    if (urlStr != null && urlStr != undefined && urlStr.length > 0) {
                                        let urls = urlStr.split(",");
                                        this.previewHttpFiles(urls);
                                    }
                                    // error msgs
                                    let msgs = res.data.msgs;
                                    if(msgs != null && msgs != undefined && msgs.length > 0) {
                                        that.$customMessage.warning(msgs, 5);
                                    }
                                } else {
                                    that.$customMessage.warning(res.data.msg, 3);
                                }
                            });

                        } else if( btnConfig.externalApi == '/outbound/extender/printDhlCargoReceipt'){
                            axios.post(ajaxurl + btnConfig.externalApi, params).then(res => {
                                if (res.data.code == 200) {
                                    // URLs
                                    let urlStr =  res.data.data.urls;
                                    if (urlStr != null && urlStr != undefined && urlStr.length > 0) {
                                        let urls = urlStr.split(",");
                                        this.previewHttpFiles(urls);
                                    }
                                    // error msgs
                                    let msgs = res.data.msgs;
                                    if(msgs != null && msgs != undefined && msgs.length > 0) {
                                        that.$customMessage.warning(msgs, 5);
                                    }
                                } else {
                                    that.$customMessage.warning(res.data.msg, 3);
                                }
                            });

                        } else if( btnConfig.externalApi == '/outbound/extender/printDhlInvoice'){
                            axios.post(ajaxurl + btnConfig.externalApi, params).then(res => {
                                if (res.data.code == 200) {
                                    // URLs
                                    let urlStr =  res.data.data.urls;
                                    if (urlStr != null && urlStr != undefined && urlStr.length > 0) {
                                        let urls = urlStr.split(",");
                                        this.previewHttpFiles(urls);
                                    }
                                    // error msgs
                                    let msgs = res.data.msgs;
                                    if(msgs != null && msgs != undefined && msgs.length > 0) {
                                        that.$customMessage.warning(msgs, 5);
                                    }
                                } else {
                                    that.$customMessage.warning(res.data.msg, 3);
                                }
                            });

                        } else if(btnConfig.externalApi =='/outbound/printCainiaoLabel'){
                            axios.post(ajaxurl + btnConfig.externalApi, params).then(data => {
                                if (data.data.code == 200){
                                    that.$message.success(data.data.msg, 3);
                                    let printData = data.data.data;
                                    webSocketPrint.doPrint("13528",printData);
                                }else {
                                    that.$customMessage.warning(data.data.msg, 3);
                                }
                            });
                        } else if(btnConfig.externalApi =='/outbound/printJdLabel'){
                            axios.post(ajaxurl + btnConfig.externalApi, params).then(data => {
                                if (data.data.code == 200){
                                    that.$message.success(data.data.msg, 3);
                                    let printData = data.data.data;
                                    webSocketPrint.doPrint("9113",printData);
                                }else {
                                    that.$customMessage.warning(data.data.msg, 3);
                                }
                            });
                        }else if(btnConfig.externalApi =='/outbound/printTiktokLabel'){
                            axios.post(ajaxurl + btnConfig.externalApi, params).then(data => {
                                if (data.data.code == 200){
                                    that.$message.success(data.data.msg, 3);
                                    let printData = data.data.data;
                                    webSocketPrint.doPrint("13888",printData);
                                }else {
                                    that.$customMessage.warning(data.data.msg, 3);
                                }
                            });
                        }else  if(btnConfig.externalApi =='/outbound/printSFLabel'){
                            axios.post(ajaxurl + btnConfig.externalApi, params).then(data => {
                                if (data.data.code == 200){
                                    this.printSfLabel(data.data.data,data.data.msg);
                                }else {
                                    that.$customMessage.warning(data.data.msg, 3);
                                }
                            });
                        } else if(btnConfig.externalApi =='/outbound/printXhsLabel'){
                            axios.post(ajaxurl + btnConfig.externalApi, params).then(data => {
                                if (data.data.code == 200){
                                    that.$message.success(data.data.msg, 3);
                                    let printData = data.data.data;
                                    webSocketPrint.doPrint("10818",printData);
                                }else {
                                    that.$customMessage.warning(data.data.msg, 3);
                                }
                            });
                        } else if(btnConfig.externalApi =='/outbound/printWphLabel'){
                            axios.post(ajaxurl + btnConfig.externalApi, params).then(data => {
                                if (data.data.code == 200){
                                    that.$message.success(data.data.msg, 3);
                                    let printData = data.data.data;
                                    webSocketPrint.doPrint("12233",printData);
                                }else {
                                    that.$customMessage.warning(data.data.msg, 3);
                                }
                            });
                        }else if(btnConfig.externalApi =='/outbound/extender/cancelJdExpressNo'){
                            axios.post(ajaxurl + btnConfig.externalApi, params).then(data => {
                                if (data.data.code == 200){
                                    that.$message.success(data.data.msg, 3);
                                }else {
                                    that.$customMessage.warning(data.data.msg, 3);
                                }
                            });
                        }
                    }

                    if( btnConfig.code == "BTN_EXPORT"){
                        if( btnConfig.externalApi == '/so/exportPackingList'){

                            let ajaxurl = ajax.ajaxUrl();
                            this.isBtnajax = true
                            let that = this
                            // 构造参数
                            let paramsData = [];

                            // 给son params 添加信息
                            if(!this.currentRelId){
                                let paramsObj = {};
                                paramsObj.key = "waveId";
                                paramsObj.value = this.waveId;
                                paramsData.push(paramsObj);
                            }else{
                                let paramsObj = {};
                                paramsObj.key = "relId"
                                paramsObj.value =  this.currentRelId;
                                paramsData.push(paramsObj);
                            }
                            // 给son params 添加箱号
                            if (this.newEditCartData.sscc != undefined) {
                                let paramsObj = {};
                                paramsObj.key = "sscc";
                                paramsObj.value = this.ssccNo;
                                paramsData.push(paramsObj);
                            }
                            let params = {
                                gmcUid: btnConfig.gmcUid,
                                uid: '',
                                btnName: btnConfig.name,
                                btnUid: btnConfig.uid,
                                params: paramsData
                            }

                            ajax.exportExcel(ajaxurl + btnConfig.externalApi,params).then(data => {
                                if(!data){
                                    return;
                                }
                                let type = data.data.type;
                                let that = this;
                                const relType = ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']
                                if( type.includes('application/json')){
                                    let reader = new FileReader()
                                    reader.onload = function (event) {
                                        let content = reader.result
                                        let msg = JSON.parse(content).msg
                                        that.$customMessage.warning(msg);
                                    }
                                    reader.readAsText(data.data)
                                    return
                                }else{
                                    var blob = new Blob([data.data], {
                                        type:
                                            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8"
                                    });
                                    var url = window.URL.createObjectURL(blob);
                                    var aLink = document.createElement("a");
                                    aLink.style.display = "none";
                                    aLink.href = url;
                                    aLink.setAttribute("download", "excel.xlsx");
                                    document.body.appendChild(aLink);
                                    aLink.click();
                                    document.body.removeChild(aLink); //下载完成移除元素
                                    window.URL.revokeObjectURL(url); //释放掉blob对象
                                }
                            }).catch(function(error) {
                                alert(error);
                            })
                            return
                        }
                    }
                }else {
                    let ajaxurl = ajax.ajaxUrl();
                    this.isBtnajax = true
                    let that = this
                    // 构造参数
                    let params = {
                        gmcUid: btnConfig.gmcUid,
                        uid: '',
                        btnName: btnConfig.name,
                        btnUid: btnConfig.uid
                    }


                    // 添加 订单号
                    if(!this.currentRelId){
                        params.waveId = this.waveId
                    }else{
                        params.relId = this.currentRelId
                    }

                    //  添加箱号
                    if (!this.showPack) {
                        if (this.searchSsccSku != null && this.searchSsccSku.length > 0){
                            params.sscc = this.searchSsccSku;
                        }
                    } else if (this.ssccNo) {
                        params.sscc = this.ssccNo;
                    }

                    axios.post(ajaxurl + api.PRINTPREVIEW, params, {
                        headers: {
                            Authorization: cookie.getToken()
                        },
                        responseType: "blob" //二进制流
                    }).then(function(res) {
                        let resHeader = res.headers;
                        let contentType = resHeader["content-type"];
                        let excelContentType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8";
                        if(excelContentType.indexOf(contentType) !=-1) {
                            //excel
                            that.isBtnajax = false
                            var data  = res;
                            if (!data) {
                                return;
                            }
                            var blob = new Blob([data.data], {
                                type:
                                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8"
                            });
                            var url = window.URL.createObjectURL(blob);
                            var aLink = document.createElement("a");
                            aLink.style.display = "none";
                            aLink.href = url;
                            aLink.setAttribute("download", "excel.xlsx");
                            document.body.appendChild(aLink);
                            aLink.click();
                            document.body.removeChild(aLink); //下载完成移除元素
                            window.URL.revokeObjectURL(url); //释放掉blob对象
                        } else {
                            //pdf
                            that.pubPdfMsgfn(res);
                        }
                    });
                }
            },
            pubPdfMsgfn(res){
                let data = res.data;
                let fileReader = new FileReader();
                let that = this
                fileReader.onload = function() {
                    try {
                        let jsonData = JSON.parse(this.result);
                        if (jsonData.code) {
                            that.$customMessage.warning(jsonData.msg);
                            that.$store.commit("updataLoading", { pbLoading: false });
                            that.isBtnajax = false
                        }
                    } catch (err) {
                        that.pubPdfUploadOk(res)
                    }
                };
                fileReader.readAsText(data)
            },
            pubPdfUploadOk(data){
                this.isBtnajax = false
                this.$store.commit("updataLoading", { pbLoading: false });
                let blob = new Blob([data.data], {type: "application/pdf;charset=utf-8"});
                let url = window.URL.createObjectURL(blob);
                window.open(url);
            },
            previewHttpFile(url) {
                let ajaxurl = ajax.ajaxUrl();
                let previewUrl = ajaxurl + "/printViewFile?filePath=" + url;
                window.open(previewUrl, '_blank');
            },
            previewHttpFiles(urls) {
                for (const url of urls) {
                    let ajaxurl = ajax.ajaxUrl();
                    let previewUrl = ajaxurl + "/printViewFile?filePath=" + url;
                    window.open(previewUrl, '_blank');
                }
            },
            toggleCheckbox(item) {
                let index = this.checkedUids.findIndex(id => id === item.uid);
                if (index > -1) {
                    this.checkedUids.splice(index, 1);
                    this.checkedItems.splice(index, 1);
                } else {
                    this.checkedUids.push(item.uid);
                    this.checkedItems.push(item);
                }
                let count = 0;
                if(this.autoPrintLable != null){
                    for(let cUid of this.checkedUids){
                        for(let aUid of this.autoPrintLable){
                            if(cUid === aUid){
                                count ++;
                            }
                        }
                    }
                }
                if(count == this.checkedUids.length){
                    this.disabledPrint = false;
                }else{
                    this.disabledPrint = true;
                }
                if(this.checkedUids.length < 1){
                    this.disabledPrint = true;
                }
            },
            previewDoc(){
                for(let item of this.checkedItems){
                    this.printByBtnConfig(item);
                }
                this.showPrint = false;
            },
            printDoc(){
                this.printCloseCtnReport(this.checkedUids);
                this.showPrint = false;
            },
            async printCloseCtnReport(items){
                let params = {
                    relId: this.orderId,
                    waveId: this.orderId,
                    sscc: this.showPack ? this.ssccNo : this.searchSsccSku,
                    ip: this.ip,
                    reportUids: items ? items.join(",") : "",
                    gmcUid: this.gmcUid,
                };
                await this.getPrinters();
                await ajax.get(api.AUTOPRINT,params).then(res => {
                    this.autoPrint(res);
                    this.resetPrint();
                })
            },
            resetPrint(){
                this.showPrint = false;
                this.disabledPrint=true;
                this.checkedUids=[];
                this.checkedItems=[];
            },
        },
    };
</script>
<style lang="less" scoped>
    .main{
        background: #F9FAFB;
        height: 100vh;
    }
    .mg10{
        margin-left: 10px;
        border-radius: 10px;
        min-width: 0;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .borderRadius{
        margin-bottom: 5px;
        border-radius: 10px;
        min-width: 0;
    }
    .gradient-orange {
        border-radius: 10px;
        height: 80px;
        box-shadow: 0 4px 12px rgba(255, 140, 0, 0.5);
        background: linear-gradient(to bottom right, #FFB500, #FF7000);
    }
    .gradient-green {
        border-radius: 10px;
        height: 80px;
        box-shadow: 0 2px 8px rgba(0, 188, 165, 0.5);
        background: linear-gradient(to bottom right, #00D293, #00BCA5);
    }
    .shadow-blue{
        background-color: #1A67FE;
        border-radius: 10px;
        height: 100px;
        box-shadow: 0 3px 10px rgba(28, 105, 255, 0.5);
    }
    .bg-white{
        padding: 10px;
        border: 1px solid #dcdfe6;
        border-radius: 10px;
        background-color: white;
        box-shadow: 0 3px 10px rgba(232, 232, 232, 1);
    }
    .bg-orange{
        height: 30px;
        padding: 0 10px 0 10px;
        border-radius: 5px;
        border: 1px solid orange;
        color: #E38D2C;
        font-weight: bold;
        background-color: #F3E7D6;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .bg-blue{
        padding: 5px;
        border-radius: 10px;
        border: 1px solid #52B7E3;
        background-color: #EFF6FF;
        margin-bottom: 10px;
    }
    .bg-yellow{
        border-radius: 10px;
        border: 2px solid #F1C9A3;
        background-color: #FFF8ED;
        font-size: 30px;
        font-weight: bold;
        padding: 20px;
        color: #803935;
    }
    .bg-tiffany-blue{
        border-radius: 10px;
        border: 2px solid #9CF5D9;
        background-color: #ECFDF5;
        font-size: 30px;
        font-weight: bold;
        padding: 20px;
        color: #024B53;
    }
    .bg-red{
        padding: 5px;
        border-radius: 10px;
        border: 1px solid #FED2D2;
        background-color: #FEF2F2;
        margin-bottom: 10px;
    }
    .bg-green{
        padding: 10px;
        border-radius: 10px;
        border: 1px solid #B9F8CF;
        background-color: #F0FDF4;
        margin-bottom: 10px;
    }
    .bg-buff{
        padding: 10px;
        border-radius: 10px;
        border: 1px solid #EEF8D0;
        background-color: #FDFCEF;
        margin-bottom: 10px;
    }
    .bg-green-tip{
        width: 80px;
        padding: 5px;
        color: white;
        display: flex;
        justify-content: center;
        border-radius: 20px;
        background-color: #00C951;
    }
    .bg-gray-tip{
        width: 80px;
        padding: 5px;
        color: white;
        display: flex;
        justify-content: center;
        border-radius: 20px;
        background-color: grey;
    }
    .font-padding{
        padding: 10px 0 0 20px;
    }
    .gradient-wathet {
        border: 1px solid #BEDBFF;
        border-radius: 10px;
        height: 80px;
        box-shadow: 0 2px 8px rgba(221, 235, 254, 0.9);
        background: linear-gradient(to bottom right, #EDF5FE, #DDEBFE);
    }
    .gradient-reseda {
        border: 1px solid #B9F8CF;
        border-radius: 10px;
        height: 80px;
        box-shadow: 0 2px 8px rgba(223, 253, 233, 0.9);
        background: linear-gradient(to bottom right, #EEFCF2, #DCFCE7);
    }
    .gradient-lilac {
        border: 1px solid #E9D4FF;
        border-radius: 10px;
        height: 80px;
        box-shadow: 0 2px 8px rgba(244, 234, 255, 0.9);
        background: linear-gradient(to bottom right, #FAF5FF, #F4EAFF);
    }
    .gradient-buff {
        border: 1px solid #FFD6A7;
        border-radius: 10px;
        height: 80px;
        box-shadow: 0 2px 8px rgba(255, 238, 215, 0.9);
        background: linear-gradient(to bottom right, #FFF6EB, #FFEED7);
    }
    .gray-span{
        margin: 5px 0 5px 0;
        padding: 0 5px 0 5px;
        border-radius: 10px;
        min-width: 40px;
        margin-left: 5px;
        background-color: #E6E6E6;
        font-weight: bold;
        height: 30px;
        display: inline-flex;
        justify-content: center;
        align-items: center;
    }
    .gray-border{
        width: 100px;
        height: 100px;
        margin: 10px;
        border: 2px solid #C5C5C5;
        align-items: center;
        justify-content: center;
        display: inline-flex;
        text-align: center;
        cursor: pointer;
        position: relative;
    }
    .checkbox-wrapper {
        position: absolute;
        top: 0px;
        right: 2px;
        z-index: 1;
        /deep/ .ant-checkbox-inner {
            border-radius: 50% !important;
        }
    }
</style>